/* instead /mxm/mxm-api/file/mxbt.js */
Ext.onReady(function() {
    window.MXBT = new mx.Configuration({
        'LOC': {
            'mx.app.core.termins.smsTags': {
                'DRIVER_PHONE': 'Driver phone',
                'ORDER_NAME': '%gt.orderReference%',
                'WEEKDAY': 'Weekday',
                'CLIENT_NAME': '%gt.clientName%',
                'PLANNED_START_TIME': 'Arrival time',
                'POSTCODE': 'Location postcode',
                'ADDITIONAL_INSTRUCTIONS': 'Additional instructions',
                'CONTACT_PERSON': '%gt.contactPerson%',
                'DRIVER_NAME': 'Driver name',
                'DEPO_PHONE': 'Distribution centre phone number',
                'PLANNED_END_TIME': 'Departure time',
                'DYNAMIC_ATTRIBUTE': 'Dynamic attribute for order',
                'PLANNED_END_DATE': 'Arrival date',
                'ACCOUNT': 'Account name',
                'COST': 'Cost of order',
                'ETA': 'Estimated time of arrival',
                'LOCATION_WIDGET': 'Location widget address',
                'DEPO_NAME': 'Distribution centre',
                'ADDRESS': 'Location address',
                'ORDER_FAIL_REASON': 'Order fail reason',
                'ORDER_COMPLETE_TIME': 'Order completing time',
                'TIME_LIMIT': 'Limits for ETA/Scheduling time of arrival'
            },
            'mx.app.mobile.pda.terms.unavInfoScreen': {
                'notes': 'Notes',
                'start': 'Start',
                'end': 'End',
                'screenName': 'Unavailability',
                'to': 'To',
                'delete': 'Delete'
            },
            'mx.app.widget.UsersInfoForm': {
                'yourPassword': 'Your password',
                'passwordsDoNotMatch': 'Passwords do not match',
                'apiAccess': 'API access',
                'phoneNumber': 'Phone number',
                'uiLanguage': 'Interface language',
                'repeatPassword': 'Repeat password',
                'name': 'Name',
                'newPassword': 'New password',
                'yourPasswordIsRequired': 'Your password is required to change password',
                'login': 'Login',
                'email': 'E-mail',
                'changePassword': 'Change password'
            },
            'mx.app.widget.WindowForm': {
                'cancel': 'Cancel',
                'warning': 'Warning',
                'duplicate': 'Save and clone',
                'ok': 'OK',
                'someFieldsAreWrong': 'Some fields are not filled out correctly.',
                'close': 'Close'
            },
            'scheduling.order.failreason.<minute>[2.': {'*]': 'minutes'},
            'mail.notify.dispatcher': {
                'subject': 'Driver {0} ({1}) will be back at the depot shortly',
                'body': 'Dear {0}! <br><br>Driver {1} ({2}) has completed {3} out of {4} stops scheduled for {5}. The scheduled time of arrival to the depot: {6}. <br><br><br><span style="color: #666666; font-size: 8pt;">Your Maxoptra Team<\/span>'
            },
            'mx.app.mobile.pda.terms.addUnScreen': {
                'add': 'Add',
                'reason': 'Reason',
                'address': 'Next available address',
                'endDate': 'End date',
                'postcode': 'Next available postcode',
                'timeZone': 'Time zone',
                'startDate': 'Start date'
            },
            'mx.app.core.termins.notifyOrderAction': {
                'DETAILS_SENT': 'Order details sent',
                'DELIVERY_STARTED': 'Driver sets "on move" for next order',
                'FAILED_ORDER': 'Order is failed',
                'BEFORE_ARRIVAL': 'N minutes before estimated time of arrival',
                'COMPLETED_ORDER': 'Order is completed'
            },
            'mx.app.core.auditProperties.Performer': {
                'schedule': 'Schedule',
                'password': 'Password',
                'driver': 'Driver',
                'expirienceDate': 'Expirience date',
                'longKey': 'Long key',
                'login': 'Login',
                'newOrders': 'New orders'
            },
            'mx.app.page.main.settings.Attributes': {
                'addTypeTitle': 'New type',
                'confirmDeleteTags': 'attributes',
                'del': 'Delete',
                'okButton': 'Save',
                'typeAlreadyExists': 'Type with name "{0}" already exists.',
                'cancelButton': 'Close',
                'areYouSureYouWantToDelete': 'Delete %a from the list?',
                'confirmDeleteTag': 'attribute',
                'addTagTitle': 'New attribute',
                'newTagName': 'Attribute name',
                'editTypeName': 'Edit type name',
                'tagAlreadyExists': 'Attribute with name "{0}" already exists.',
                'add': 'Add',
                'typesMinimumSize': 'Type name can\'t be empty',
                'types': 'Types',
                'edit': 'Edit',
                'customIcons': 'Customize icons',
                'incompatibleTypes': 'Incompatible vehicle requirements',
                'tagsMaximumSizeWarning': 'Attribute name length must not exceed 255 symbols. Please edit the name you entered or it will be truncated to 255 sumbols.',
                'confirmDeleteType': 'type',
                'tagsMinimumSize': 'Attribute name can\'t be empty',
                'abbreviation': 'Abbreviation',
                'areYouSureYouWantToDeleteTitle': 'Confirmation',
                'validationError': 'Validation error',
                'remove_icon': 'Remove icon',
                'tags': 'Attributes',
                'newTypeName': '%gt.name%',
                'typesMaximumSizeWarning': 'Type name length must not exceed 255 symbols. Please edit the name you entered or it will be truncated to 255 sumbols.',
                'change_icon': 'Add/Change icon...',
                'tagsMaximumSize': 'Attribute name must not exceed 255 symbols',
                'confirmDeleteTypes': 'types',
                'editTagName': 'Edit attribute name',
                'customIcon': 'Customize icon',
                'notEmptyTypesCanNotBeDeleted': 'Types with attributes cannot be deleted. Please delete all attributes first.',
                'typesMaximumSize': 'Type name must not exceed 255 symbols'
            },
            'mx.time.terms': {'time': 'time', 'current_time': 'Current time', 'in_past': 'in past'},
            'com.magenta.maxoptra.service.impl.geobase.default_vehicle_type': {
                'All': 'All',
                'Bus': 'Bus',
                'AllButEmergency': 'AllButEmergency',
                'CarPool': 'CarPool',
                'OtherLCV': 'OtherLCV',
                'StandardDouble': 'StandardDouble',
                'Pedestrian': 'Pedestrian',
                'TractorSemiTrailer': 'TractorSemiTrailer',
                'Truck': 'Truck',
                'IntermediateDouble': 'IntermediateDouble',
                'Default': 'Default',
                'Auto': 'Auto',
                'Triple': 'Triple',
                'LongDouble': 'LongDouble',
                'Unknown': 'Unknown',
                'Taxi': 'Taxi',
                'StraightTruck': 'StraightTruck',
                'Emergency': 'Emergency'
            },
            'mx.app.page.Main': {
                'exit': 'Exit',
                'help': 'Help',
                'role': 'Role',
                'changingRole': 'Changing role',
                'comboEmptyText': 'Select a role...',
                'paymentNotification': 'Please note \u2013 there are outstanding payments relating to your account.  Please contact us to arrange payment asap.  Thank you.',
                'windowTitle': 'Update user settings',
                'user': 'User'
            },
            'mx.app.page.main.dispatching.Filter': {
                'cancel': 'Cancel',
                'orderType': 'Order type',
                'orderPriority': 'Order priority',
                'selectClient': 'Select client...',
                'clearCircleBtn': 'Clear region',
                'selectRegion': 'Select region...',
                'windowTitle': 'Filter & sorting. Resources and Orders',
                'orderPriorityMidHigh': 'Medium',
                'orderPriorityHigh': 'High',
                'client': 'Client',
                'selectType': 'Select type...',
                'startTime': 'Start time',
                'ok': 'OK',
                'emptyGradeText': 'Please, select at least one grade checkbox',
                'thirdpartyResources': 'Show thirdparty resources',
                'resources': 'Resources',
                'emptyValue': 'Empty',
                'emptyPriorityText': 'Please, select at least one priority checkbox',
                'orderPriorityNormal': 'Normal',
                'proximity': 'Geographical proximity',
                'allValue': 'All',
                'drawCircleBtn': 'Draw region',
                'regionalDivision': 'Regional division',
                'reset': 'Reset',
                'resourceGrade': 'Resource grade',
                'orders': 'Orders',
                'resourceType': 'Resource type'
            },
            'mx.app.core.languages': {'ru': 'Русский', 'en': 'English'},
            'mx.app.widget.MapCircle': {'search': 'Search', 'searchPosition': 'Search position', 'map': 'Map'},
            'mx.app.page.main.dispatching.RunPlanning': {
                'planningStartedAt': 'Started at',
                'distanceCalculation': 'Distance calculation',
                'planningInProgressWantStopPlanning': 'Planning in progress. Do you want to cancel current session and start the new one?',
                'planningSessionIsRunning': 'Planning session is running',
                'wantStopPlanning': 'Are you sure you want to stop planning?',
                'delete': 'Unallocate',
                'planningOptimization': 'Planning optimization',
                'resultStoring': 'Saving results',
                'planningStartedBy': 'by',
                'saving': 'Saving results...',
                'sessionProgress': 'Session progress',
                'result_mes': 'Planning result',
                'of': 'of',
                'scheduling': 'Planning & Optimization',
                'terminateSession': 'Terminate session',
                'runPlanning': 'run planning...'
            },
            'mx.app.page.main.settings.Resources': {
                'broken': 'Broken',
                'headerAoc': 'Area of control',
                'filterCriteria': '',
                'headerDeviceCode': 'Assigned device',
                'headerName': 'Name',
                'performer': 'performer',
                'filterBlank': 'All',
                'waiting': 'Waiting',
                'idle': 'Idle',
                'unavailable': 'Unavailable',
                'performing': 'Performing',
                'truck': 'truck',
                'onRoute': 'On route',
                'filterBy': 'Filter by area:',
                'headerId': 'ID / Call sign',
                'headerTypes': 'Types',
                'inactive': 'Inactive',
                'driver': 'Driver',
                'headerStatus': 'Status',
                'headerAttributes': 'Attributes'
            },
            'Ext.form.TextField': {'blankText': 'This field is required'},
            'action': {
                'DELAY_30': 'Late by 30 minutes',
                'DELAY_10': 'Late by 10 minutes',
                'DELAY_60': 'Late by 1 hour',
                'DELAY_15': 'Late by 15 minutes',
                'DELAY_5': 'Late by 5 minutes'
            },
            'mx.app.page.main.settings.AreasOfControl': {
                'headerDispatcher': 'Dispatcher',
                'filterCriteria': '',
                'headerName': 'Name',
                'filterBlank': 'All',
                'headerRegdivision': 'Regional division',
                'filterBy': 'Filter by Regional division:',
                'errorsUsersAOCAlreadyOccupiedByUser': 'Selected Area of control is already occupied by user'
            },
            'ord-ejb.upload': {'<can-not-upload>': 'Upload failed.'},
            'mx.app.widget.AreasOfControlForm': {
                'name': 'Name',
                'regionalDivision': 'Regional division',
                'regionError': 'Please, select any regional division',
                'dispatcher': 'Dispatcher',
                'areaData': 'Area data',
                'areaHint': 'Use the map icon to select on the map the geographic area covered by this Area of Control.'
            },
            'mx.comp.dispatching.ShowOnMapColumn': {'tooltip': 'Show on map'},
            'mx.app.mobile.pda.terms.commonsLabel': {
                'serverStatus': 'Server status',
                'pageTitle': 'Welcome to Mobile Client',
                'latitude': 'Latitude',
                'back': 'Back',
                'refresh': 'Refresh',
                'p_symbol': 'P',
                'menu': 'Menu',
                'd_symbol': 'D',
                'PICK_UP': 'Pick up',
                'DROP_OUT': 'Drop out',
                'u_symbol': 'U',
                'offline': 'Offline',
                'online': 'Online',
                'addr': 'Addr',
                'longitude': 'Longitude',
                'status': 'Status'
            },
            'mx.comp.GeoComboBox': {
                'searchOnMap': 'Search on map',
                'addressInvalid': '{0} is invalid address. Check it on map',
                'pointPositionOnMap': 'Point position on map',
                'searchForAddress': 'Search'
            },
            'mx.app.core.auditProperties.AccountMainSettings': {
                'zip': 'ZIP / Postal code',
                'country': 'Country',
                'streetMore': 'Street address (more information)',
                'city': 'City',
                'phone': 'Phone',
                'street': 'Street address',
                'industry': 'Industry name',
                'id': 'ID',
                'state': 'State / Province',
                'email': 'E-mail'
            },
            'mx.app.page.main.settings.Landmarks': {
                'headerName': 'Name',
                'exportBtn': 'Export',
                'importBtn': 'Import',
                'headerAddress': 'Address',
                'map': 'Map'
            },
            'mx.lang.terms': {'from': 'from'},
            'ext.date': {
                'sunday': 'Sunday',
                'saturday': 'Saturday',
                'tuesday': 'Tuesday',
                'friday': 'Friday',
                'thursday': 'Thursday',
                'wednesday': 'Wednesday',
                'monday': 'Monday'
            },
            'mx.app.widget.FutureAvailabilityEditForm': {
                'datetime': 'Time',
                'comment': 'Comment',
                'location': 'Location'
            },
            'mx.app.mobile.pda.terms.jobInfoScreen': {
                'drop': 'Drop duration',
                'hours': 'h',
                'notes': 'Notes',
                'phone': 'Contact phone',
                'person': 'Contact person',
                'edh': 'Estimated driving hours',
                'name': 'Order name',
                'action': 'Action',
                'pickup': 'Pickup duration',
                'id': 'Order ID',
                'screenName': 'Job info',
                'info': 'Info'
            },
            'mx.app.widget.NotificationsEditForm': {
                'message_email': 'E-mail message',
                'fileName': 'File name',
                'period': 'Notification before',
                'selectTag': 'Select tag',
                'subject': 'E-mail subject',
                'action': 'Order action',
                'active_sms': 'Send sms',
                'active_email': 'Send e-mail',
                'message_sms': 'Sms message',
                'addTag': 'Add',
                'tagIncorrect': 'The message contains wrong tag',
                'tags': 'Tags'
            },
            'order.log': {'<system>': 'System'},
            'mx.app.core.termins': {
                'NEW': 'New',
                'RESUMED': 'Resumed',
                'orderPluralCAP': 'Orders',
                'driverCAP': 'Driver',
                'regionalDivisionCAP': 'Regional division',
                'language': 'en',
                'COMMITTING': 'Waiting to be sent',
                'regionalDivisionPlural': 'regional divisions',
                'PICKUP_ARRIVED': 'Arrived at pick up location',
                'YARD': 'yd',
                'FAILED': 'Failed',
                'DELIVERY_STARTED': 'Delivery started',
                'ALLOCATED': 'Allocated',
                'landmark': 'landmark',
                'order': 'order',
                'all': 'All',
                'resource': 'resource',
                'DETAILS_SENDING': 'Details sending',
                'DECIMETRE': 'dm',
                'DELIVERY_ON_MOVE': 'Delivery order started',
                'PICKUP_STARTED': 'Pick up started',
                'POUND_UK': 'pounds',
                'thirdpartyResources': 'Show thirdparty resources',
                'CENTIMETER': 'cm',
                'UNCOMMIT': 'Unlock',
                'loading': 'Loading...',
                'regionalDivisionPluralCAP': 'Regional divisions',
                'UNALLOCATED': 'Unallocated',
                'MILE': 'mi',
                'LEAGUE': 'league',
                'METER': 'm',
                'driver': 'driver',
                'orderCAP': 'Order',
                'SUSPENDED': 'Suspended',
                'DELIVERY_FINISHED': 'Delivery finished',
                'PICKUP_FINISHED': 'Pick up finished',
                'DOLLAR': '$',
                'AVAILABLENOW': 'Available now',
                'UNALLOCATE': 'Unallocate',
                'resourcePlural': 'resources',
                'resourcePluralCAP': 'Resources',
                'DELIVERED': 'Delivered',
                'CLOSED': 'Completed',
                'WAITING_FOR_ACCEPTANCE': 'Waiting to be accepted',
                'DANISH_KRONE': 'kr',
                'save': 'Save',
                'landmarkCAP': 'Landmark',
                'error': 'Error',
                'EURO': '\u20ac',
                'FOOT': 'ft',
                'orderPlural': 'orders',
                'COMPLETED': 'Completed',
                'DELIVERY_ARRIVED': 'Arrived at delivery location',
                'DIRHAM': 'DH',
                'STARTED': 'Started',
                'performerPlural': 'performers',
                'POUND': '£',
                'MILLIMETER': 'mm',
                'performer': 'performer',
                'KILOMETRE': 'km',
                'INCH': 'in',
                'LATE_TO_COMPLETE': 'Late to complete',
                'h': 'h',
                'PICKUP_ON_MOVE': 'Pickup order started',
                'COMMITTED': 'Sent',
                'm': 'm',
                'TONNE': 'tonne',
                'resourceCAP': 'Resource',
                'COLLECTED': 'Collected',
                'KILOGRAM': 'kg',
                'deleting': 'Deleting...',
                'DETAILS_SENT': 'Waiting to be accepted',
                'GRAM': 'gram',
                'LATE_TO_START': 'Late to start',
                'TON_UK': 'ton(UK)',
                'areaOfControlCAP': 'Area of control',
                'regionalDivision': 'regional division',
                'performerPluralCAP': 'Performers',
                'NAUTICAL_MILE': 'n.m.',
                'DELIVERY_DEPARTED': 'Departed from delivery location',
                'performerCAP': 'Performer',
                'WAITING_TO_BE_SENT': 'Waiting to be sent',
                'PICKUP_DEPARTED': 'Departed from pick up location',
                'TON_US': 'ton(US)'
            },
            'mx.app.widget.LandmarksForm': {
                'address': 'Address',
                'cannotSaveLandmark': 'Cannot save landmark',
                'name': 'Name',
                'description': 'Description',
                'landmarktypes': 'Landmark type',
                'regionError': 'Please, select any region',
                'region': 'Maps',
                'account': 'Account',
                'tags': 'Tags'
            },
            'mx.app.widget.MapForm': {
                'cancel': 'Cancel',
                'startDrawHandle': 'Click to start drawing shape.',
                'address': 'Address',
                'continueDrawHandle': 'Click to continue drawing shape.',
                'intersectionError': 'Intersection detected',
                'searchPosition': 'Search position',
                'invalidate': 'No valid poligon line can be found',
                'empty': 'No poligon can be found',
                'drawingCancel': 'Cancel drawing',
                'endDrawHandle': 'Click first point to close this shape.',
                'search': 'Search',
                'latlon': 'Lat. / Lon.',
                'drawingPoligon': 'Draw new poligon shape.',
                'map': 'Map'
            },
            'mx.comp.DayField': {'timeFieldEmptyTextLabel': 'hh:mm', 'regexText': 'Time must be in hh:mm format'},
            'mx.app.widget.CoreEventsManager': {
                'schedulingStarted': 'Scheduling started',
                'scheduling': 'Scheduling',
                'schedulingFinished': 'Scheduling finished',
                'schedulingError': 'Scheduling error'
            },
            'mx.app.page.main.Dispatching': {
                'editOrder': 'Edit order',
                'confirmDeleteOrders': 'Are you sure that you want to delete the selected orders?',
                'continueAnyway': 'Continue anyway?',
                'showTruckInfo': 'Show resource info',
                'logTitle': 'Log',
                'availibilityTime': 'Availibility time',
                'dispatcher': 'Dispatcher',
                'mapSettings': 'Map settings',
                'runPlanning': 'Run planning',
                'order': 'Orders ({0})',
                'filterOff': 'Filter is off',
                'importXML': 'Import XML',
                'dispatcherTitle': 'Dispatcher {0}',
                'truckTitle': 'Resource {0}',
                'sortOrders': 'Sort orders',
                'resource': 'Resources ({0})',
                'allocationTitle': 'Confirmation',
                'showSchedule': 'Show schedule',
                'loading': 'Loading...',
                'orderSortDestination': 'Drop location',
                'showHistory': 'Show history',
                'name': 'Name',
                'orderSortCreateDate': 'Creation date and time',
                'orders': 'orders',
                'displayAllResources': 'Show on map all resources',
                'newOrder': 'New order',
                'resourceSortName': 'Name',
                'device': 'Device',
                'noOrdersUnderFilter': 'No orders suitable to the filter conditions',
                'noResources': 'No available resources',
                'noResourcesUnderFilter': 'No resources suitable to the filter conditions',
                'showOnMapTooltip': 'Show on map',
                'clickResource': 'Click on resource to select',
                'connectionErrorMessage': 'Unexpected error occurred',
                'orderSortSource': 'Pickup location',
                'orderSortEndTime': 'Start before',
                'showDispatcherInfo': 'Show Dispatcher contact data',
                'orderSortPriority': 'Importance',
                'addOrder': 'Add order',
                'client': 'Client',
                'deleteOrder': 'Delete order',
                'map': 'Map',
                'noOrders': 'No open orders',
                'allocation': 'Allocation',
                'performer': 'Performer',
                'connectionErrorTitle': 'Connection Error',
                'sortResources': 'Sort resources',
                'match': 'Allocate!',
                'allocationMessage': 'Allocation these resource and order can take a while. Continue anyway?',
                'clickOrder': 'Click on order to select',
                'resources': 'resources',
                'confirmDeleteOrdersTitle': 'Confirmation',
                'areaOfControl': 'Area of control',
                'filterOn': 'Filter is on',
                'orderSortClient': 'Customer name',
                'matchingMessage': 'Allocation resource {0} with order {1}',
                'regionalDivision': 'Regional division',
                'location': 'Location',
                'finishedTitle': 'Information',
                'orderSortStartTime': 'Start after',
                'resourceSortCallSign': 'Call sign'
            },
            'mx.app.core.termins.routing_mode': {'car': 'Car', 'truck': 'Truck'},
            'mx.app.page.main.dispatching.MapSettings': {
                'cancel': 'Cancel',
                'radiusRadio': 'Nearest orders/resources within (miles)',
                'countRadio': 'Number of nearest orders/resources',
                'fieldsTitle': 'Show on map',
                'showNearest': 'Show for selected orders/resources',
                'landmarks': 'Show points of interest',
                'resourcesTracking': 'Show the actual Resource route',
                'ok': 'OK',
                'title': 'Map settings',
                'ordersRoutes': 'Show the planning Order route'
            },
            'mx.app.widget.GeoRegionWindow': {
                'clear': 'Clear',
                'polygonCheckingMsg': 'Checking polygon integrity',
                'check': 'Finish',
                'polygonValidationError': 'This polyline is not valid polygon',
                'ok': 'Save',
                'polygonValidationErrorTitle': 'Error'
            },
            'mx.scheduler': {
                '<button_cancel>': 'Cancel',
                '<button_plan_now>': 'Plan now',
                '<button_replace>': 'Replace',
                '<button_force>': 'Force',
                '<button_ok>': 'OK'
            },
            'mx.comp.ContactDetailsList': {
                'mobile': 'Mobile',
                'officephone': 'Office num.',
                'fax': 'Fax',
                'email': 'E-mail'
            },
            'mx.app.widget.HelpForm': {'text': 'To find the information on Maxoptra features and to know how Maxoptra works please refer to <a href="http://doc.maxoptra.com/docs/display/MX/Maxoptra+for+Distribution">Maxoptra Documentation.<\/a> <br> <br>If you cannot solve your problem by yourself please contact our Maxoptra Support Team on e-mail at <a href="mailto:support@maxoptra.com">support@maxoptra.com<\/a> and we shall contact and help you shortly.'},
            'Ext.form.ComboBox': {'loadingText': 'Loading...'},
            'mx.app.widget.MapKeyEditForm': {
                'keyData': 'Key dat',
                'clientName': 'Client name',
                'geocoding': 'For geocoding',
                'domain': 'Domain',
                'name': 'Name',
                'options': 'Options',
                'mapId': 'Map Id',
                'region': 'Region',
                'keyString': 'Key',
                'url': 'URL'
            },
            'mx.app.core.auditProperties.Resource': {
                'odometer': 'Odometer',
                'optLock': 'Opt lock',
                'transitTime': 'Transit time',
                'areaOfControl': 'Area of control',
                'type': 'Type',
                'isResponding': 'Is responding',
                'eta': 'Eta',
                'driver': 'Driver',
                'referenceNumber': 'Registration Number',
                'trackingInfo': 'Tracking info',
                'name': 'Name',
                'regionalDivision': 'Regional division',
                'location': 'Location',
                'device': 'Device',
                'direction': 'Direction',
                'status': 'Status'
            },
            'mx.app.widget.OrdersEditForm': {
                'drop': 'Drop',
                'dropDuration': 'Drop duration',
                'line_units': 'miles',
                'estimatedDrivingTimeCameFromGeoRouting': 'Estimated parameters are provided by external geo routing service',
                'clientName': 'Client name',
                'orderId': 'ID',
                'isCollection': 'Collection',
                'contactPerson': 'Contact person',
                'typesComboboxEmptyLabel': 'Select a type',
                'capacity': 'Capacity',
                'serverCouldntCalculateTimeAndDistance': 'Server couldn\'t calculate time and distance for given pickup and drop locations',
                'incorrentDropStart': 'Drop start time should be later than pickup start time',
                'incorrentDropFinish': 'Drop finish time should be later than pickup finish time',
                'requiredField': 'This field is required',
                'drivingDistance': 'Driving distance',
                'contactNumber': 'Contact number',
                'finish': 'Finish',
                'estimatedDrivingTime': 'Estimated driving time',
                'currentDepotTimezone': 'Current depot timezone',
                'estimatedDrivingTimeTakenFromReversedGuide': 'Parameters are estimated for reversed routing guide (from drop to pickup)',
                'selectAttributes': 'Select one or more attributes for each type of order if necessary.',
                'createDate': 'Order Time / Date',
                'orderName': 'Order name',
                'pickupDuration': 'Pickup duration',
                'estimatedDrivingTimeIsRequired': 'This parameter is required, it should be greater than zero',
                'locationsAreSame': 'Pickup and drop are scheduled for same location',
                'timeWindow': 'Pickup start time window',
                'types': 'Types',
                'contactEmail': 'Contact E-mail',
                'dropTimeZone': 'Drop time zone',
                'start': 'Start',
                'pickup': 'Pickup',
                'capacityInSeats': 'Capacity in seats',
                'areaOfControl': 'Area of control',
                'priority': 'Priority',
                'pickupTimeZone': 'Pickup time zone',
                'tags': 'Attributes',
                'loadingEstimate': 'Loading estimated time and distance...',
                'defineLocation': 'Define location where the order starts.',
                'incorrectTimeWindow': 'Incorrect time window. End time must be greater than start time',
                'defineImportance': 'Define the order/customer importance for the business.',
                'comment': 'Comment',
                'locations': 'Locations',
                'newOrder': 'New order',
                'additionalInstructions': 'Additional instructions'
            },
            'ord-ejb.parse.orderitem.failreason': {'<invalid-json-configuration>': 'Can not parse invalid order item fail reasons configuration string.'},
            'com.magenta.maxoptra.ord.beans.mobile': {
                'truckID': 'Resource ID',
                'truckName': 'Resource name',
                'driverID': 'Driver ID',
                'driverCallsign': 'Driver callsign',
                'driverName': 'Driver name',
                'driverPhone': 'Driver phone',
                'deviceID': 'Device ID',
                'performerID': 'Performer ID'
            },
            'mx.app.widget.DispatchFilterForm': {
                'normal': 'Normal',
                'orderType': 'Order type',
                'week': 'One week',
                'exportBtn': 'Export schedule',
                'orderPriority': 'Order priority',
                'waitMsg': 'Please Wait...',
                'year': 'One year',
                'thirdpartyResources': 'Show thirdparty resources',
                'mid': 'Medium',
                'orderStatus': 'Order status',
                'error': 'Error',
                'orderResourceName': 'Order / Resource name',
                'reportPeriod': 'Report period',
                'waitTitle': 'Exporting',
                'high': 'High',
                'month': 'One month',
                'reportDate': 'Report date',
                'allValue': 'All',
                'drawCircleBtn': 'Draw circle',
                'regionalDivision': 'Regional division',
                'applyBtn': 'Apply',
                'resourseType': 'Resource type'
            },
            'mx.app.page.main.settings.CustomerLocations': {
                'locationIsVerified': 'Verified',
                'locationIsVerifiedYes': 'Yes',
                'locationIsVerifiedNo': 'No'
            },
            'mx.app.mobile.pda.terms.loginPage': {
                'password': 'Password',
                'messageInvalidLogin': 'Invalid login or password',
                'submit': 'Submit',
                'login': 'Login',
                'messageServiceProblem': 'Sorry, some service problems. Try later.'
            },
            'mx.app.widget.ResourcesEditForm': {
                'tagsComboboxHint': 'Select one or more attributes for each type of resource if necessary.',
                'color': 'Color',
                'homeLocationHint': 'The base location (a city, a station) to which the resource belongs.',
                'milesPerHour': 'mph',
                'login': 'Login',
                'assignedDevice': 'Assigned device',
                'callSign': 'Call sign',
                'capacity': 'Capacity',
                'password': 'Password',
                'spinnerMinValue': 'min value: {0}',
                'maxSpeedHint': 'Max speed of the resource.',
                'id': 'ID',
                'per': 'per',
                'deviceType': 'TCP Source',
                'alertMessage': 'Would you like to proceed with resource editing? In that case, there can be possible errors in schedule until the next planning',
                'types': 'Types',
                'proceedAnyway': 'Proceed anyway?',
                'capacityInSeats': 'Capacity in seats',
                'maxSpeed': 'Max speed',
                'areaOfControl': 'Area of control',
                'automaticPlanningWillNotBeAvailable': 'Automatic scheduling of this resource won\'t be available because:',
                'typesComboboxHint': 'Define available types of resources.',
                'performer_fieldset': 'Performer',
                'spinnerMaxValue': 'max value: {0}',
                'tags': 'Attributes',
                'kmPerHour': 'km/h',
                'driver': 'Driver',
                'plannedEarnings': 'Planned earnings',
                'homeLocation': 'Home location',
                'name': 'Name',
                'regionalDivision': 'Regional division',
                'resourceAvailabilityNotSpecified': '- Resource availability is not specified;',
                'comment': 'Comment',
                'spinnerValueShouldbeNumber': 'this field should be a number',
                'aocRequiredForHomelocation': 'Area of control should be chosen to open map',
                'maxSpeedNotSpecified': '- Max speed is not specified;'
            },
            'mx.app.core.auditProperties': {
                'cutoffTime': 'Cut-off time',
                'automatic': 'Automatic',
                'schedulingMode': 'Scheduling mode',
                'manual': 'Manual',
                'startingPeriod': 'Starting period',
                'rejectOrders': 'Reject orders',
                'activeScheduleOrders': 'Active schedule orders',
                'commitTime': 'Accept time',
                'accountStrategies': 'Account strategies',
                'id': 'ID',
                'acceptanceResource': 'Acceptance resource',
                'scheduleOrders': 'Schedule orders',
                'sendDetails': 'Send details'
            },
            'mx.app.page.main.settings.Users': {
                'coordinator': 'Coordinator',
                'headerName': 'Name',
                'accountant': 'Magenta Accountant',
                'manager': 'Manager',
                'super_admin': 'Magenta Administrator',
                'admin': 'Account Administrator',
                'headerLogin': 'Login',
                'headerRoles': 'Roles',
                'dispatcher': 'Dispatcher',
                'sales': 'Order Entry',
                'headerAPIAccess': 'API access'
            },
            'mx.app.core.auditProperties.Landmark': {
                'lastTimeUsed': 'Last time used',
                'address': 'Address',
                'latitude': 'Latitude',
                'description': 'Description',
                'tags': 'Tags',
                'accountId': 'Account ID',
                'regionId': 'Region ID',
                'name': 'Name',
                'useCount': 'Use count',
                'region': 'Region',
                'favorite': 'Favorite',
                'account': 'Account',
                'longitude': 'Longitude'
            },
            'mx.comp.DrawCircle': {
                'noCircleDrawn': 'Please, put 2 points on map (one for center and one for radius)',
                'circleWithRadius': 'Circle with radius of {0} km',
                'mapWindowTitle': 'Draw a circle on map (mark 2 points - one for center and one for radius)',
                'error': 'Error',
                'removeCircle': 'Remove this filter'
            },
            'com.magenta.maxoptra.service.impl': {
                'enablePlanFact': 'Enable Track&Trace control',
                'enableSwapSchedulesAfterFastAlgorithmLabel': 'Enable swap schedules after fast algorithm',
                'sendToBoth': 'Universal and Maxunits',
                'disableStopDetectionBySpeed': 'Disable stops detection by speed threshold',
                'allowMultiRegionalDivisionToManager': 'Manager can be assigned to several Regional Divisions',
                'reimportFieldOrder': 'The order of the fields of reimport',
                'enableManifestSettings': 'Enable manifest templates editor',
                'savingsResequenceAtTheEnd': 'Resequence at the end',
                '<gis_thread_count-label>': 'Matrix calculation thread count',
                'pickupDurationGreaterThan1': 'Pickup duration greater than 1',
                'planFactPointSequence': 'Track & trace point sequence',
                'sourceAddressNumberingPlanIndicator': 'Source address NPI',
                'accountSmtpEnabledTls': 'TLS enabled',
                'pickupDurationPerUnit': 'Variable duration per capacity unit collection',
                '<gis-locale>': 'Geocoding locale',
                '<use_map_provider>': 'Use Map Provider',
                'timeUnloadingLabel': 'Fixed operation duration',
                '<ptv_hazardous_to_waters_goods-label>': 'Avoid segments with hazardous to waters goods restrictions',
                'notifyOrderActionCompletedOrder': 'Enable notification on completed order',
                'MobileNotification': 'Notification Properties',
                '<mobile_maxunites_yandex_client_id>': 'Yandex Client Id',
                'accountSmtpFromName': 'Name',
                'enableSchedulingZonesTab': 'Territories',
                'checkLocationConfiguration': 'Check Location Configuration',
                'widgetInternal': 'On your customer website',
                'useCustomOrderCsvTemplate': 'Use order import template',
                'enableWarehouseInstructionsReportTab': 'Warehouse Instructions Report',
                'savingsResequenceOnViolations': 'Resequence on violations',
                'memoryCacheCapacity': 'Memory cache capacity',
                'searchRadius': 'Search radius (km)',
                'allowedBreakShift': 'Allowed break shift',
                'enableRouteRequestsSnapshotLabel': 'Enable route requests snapshot',
                'snapshotEnableLabel': 'Enable snapshots',
                'enableDeliveryCostByTagReport': 'Delivery cost per regions report',
                'enableSwapSchedulesAfterOptimizationAlgorithmLabel': 'Enable swap schedules after optimization algorithm',
                'sharingWorkEquallyVariance': 'Working time deviation',
                'orderWeight': 'Weight',
                'externalSystemIntegrationEnable': 'Enable external system integration in system lifecycle events',
                'supportsSingleAreaOfControl': 'Supports single area of control',
                'notifyOrderActionBeforeNDay': 'Enable notification on before N days',
                '<geoinformsputnik-label>': 'Geo Inform Sputnik Maps',
                'smsNotificationsEnabled': 'Enable sms notifications',
                'addressNumberingPlanIndicator': 'Address NPI',
                'accountConfigurationUpdateSuccessful': 'Account configuration has been successfully updated',
                '<use_map_key-label>': 'Use map Key',
                'planningStrategyLabel': 'Planning strategy',
                'reverseGeocodingProvider': 'Reverse geocoding provider',
                'systemType': 'System type',
                'maxunitesMobileAllowToPassSeveralRuns': 'Allow to pass several runs',
                'useAccurateResequenceEstimation': 'Use Accurate Resequence Estimation',
                'numeratePickup': 'Numerate pickup jobs',
                'enablePlanningScreen': 'Enable planning screen',
                '<crowflight-label>': 'Crowflight',
                'vehicleData': 'Vehicle data',
                'defaultRunPlanningAction': 'Default action',
                'ipCheckEnabled': 'IP check enabled',
                'allowUseJobPriorities': 'Allow use job priorities',
                'enableIncrementalSchedulingLabel': 'Enable Incremental scheduling',
                'savingsReduceConstWithSingleJobRun': 'Reduce cost with single job run',
                '<mobile_maxunites_enabled>': 'Enable Maxunites mobile client integration',
                'enableOverallDeliveryAccuracyReportTab': 'Overall delivery accuracy report',
                'enableDirectTimeCalculationLabel': 'Calculating start times of pickups, drops and lunches on server side',
                'geocoderFromCsvKey': 'CSV import',
                '<ptv_max_truck_weight-label>': 'Truck max weight, kg',
                '<routing_profile-label>': 'Routing profile',
                '<correction-factor>': 'Driving time correction factor',
                'allowableTimeToArriveToDrop': 'Allowable time to arrive to drop location (min)',
                'emergency-group': 'Emergency',
                'reports': 'Reports parameters',
                'fileEncoding': 'File encoding',
                '<use_ferries-label>': 'Use ferries when routing',
                'dropDurationGreaterThan1': 'Drop duration greater than 1',
                'updateLandmarkByDriverResponse': 'By driver response',
                'sharingWorkEqually_amongAllDrivers': 'Among all available resources',
                'showAlerts': 'Show alerts',
                'restAPIIntegrationLogs': 'REST integration logs',
                'connectionType': 'Connection type',
                'localSearchStrategy': 'Local search strategy',
                'enableBackgroundDistanceMatrixCalculation': 'Enable background distance matrix calculation',
                '<ptv-label>': 'PTV',
                'systemPassword': 'System password',
                'enableManagerRole': 'Enable Manager role',
                'enableStrictTimeWindowValidation': 'Validate orders \'timewindows within customer locations\' days of availability.',
                'breakGroup': 'Breaks',
                'scheduleOrders': 'Schedule orders',
                'resourceIdAttributeEnabled': 'Show resource ID on edit form',
                'schedulerGroup': 'Scheduling',
                'attachmentOrderPhotoQuality': 'Image quality',
                'distanceMatrixUpdateEnabled': 'Enable updating of distance matrix',
                'widgetExternal': 'On the Maxoptra domain',
                'allowMultiDispatcherToAoC': 'Several Dispatchers can manage one Area Of Control',
                'allowMultiManagerToRD': 'Several Managers can manage one Regional Division',
                'enableRemoteForwardGeocoding': 'Enable External Forward Geocoding',
                'static': 'Fixed',
                '<transit_mode_definition-label>': 'Transit Mode Options',
                'NoLocalSearch': 'No local search',
                '<routing_url-label>': 'Routing service URL',
                'notifyOrderActionDetailsSent': 'Enable notification on sent details',
                'enablePerformerRole': 'Enable Performer role',
                'widgetTypeGroup': 'Widget group',
                'scheduleColumnsConfiguration': 'Schedule columns configuration',
                'enableSpeedZonesTab': 'Enable Speed Zones',
                'newAccountPeriod': 'How long the tutorial video should appear after login (in days)',
                'resourceHasCapacityInSeats': 'Take into account the Capacity In Seats for resource',
                '<disable_persistence_cache-label>': 'Disable persistence cache',
                '<ptv_max_truck_height-label>': 'Truck max height, cm',
                'breakDuration': 'Break duration',
                'useOrderPriority': 'Use order priority',
                'showReleaseNotesForDispatcher': 'Show new release data to the dispatcher',
                'maxunitesOrderParameters': 'Maxunites Order Parameters',
                'enableRateDelivery': 'Enable rate delivery',
                'defaultWorkingIntervalForAreaOfControls': 'Default working interval for area of controls',
                'sendToUniversal': 'Universal only',
                'drivingTimeBeforeBreak': 'Driving time before break',
                'numerateDrop': 'Numerate delivery jobs',
                'singleRegionalDivisionName': 'Single regional division name',
                'resourceLimits': 'Vehicle limits',
                'unloadingTimeTolerance': 'Tolerance of planned time for unloading from the actual (in percent)',
                'enableRemoveScheduleBeforeImport': 'Enable remove schedule before import',
                '<veeroute-label>': 'VeeRoute',
                'showResourcesIndependentlyAoc': 'Take into account resources independently for area of controls',
                '<google_map_type-label>': 'Map type',
                'MANUAL': 'Manual',
                'csvImportGroup': 'CSV import parameters',
                'destinationAddressTypeOfNumber': 'Destination address TON',
                'scheduleOptimizationTimeout': 'Optimisation duration',
                'MobileWorkflow': 'Mobile Workflow Properties',
                '<ptv_avoid_urban_areas-label>': 'Avoid urban areas',
                'accountSmtpEmailHost': 'SMTP host',
                'allowSeveralRunsPerDayLabel': 'Allow several runs for a vehicle per day',
                'attemptsNumberToSendSms': 'Attempts number to send sms',
                'drivingTime': 'Driving Time',
                'planFactShowVehicleTrackTrace': 'Show "Vehicle Track&Trace" page',
                'userName': 'User Name',
                'workingTimeBeforeBreak': 'Working time before break',
                '<yahoo-label>': 'Yahoo',
                '<enable_logging-label>': 'Enable logging',
                'intercomWidget': 'Use Intercome Widget',
                'enableAlertTypesTab': 'Alert Types',
                'enableOrderItemsTab': 'Enable order items',
                'reportedEndTime': 'Departure reported',
                'resourceHasCapacity': 'Take into account the Capacity for resource',
                'enableHMSProvidersTab': 'HMS Providers',
                'timeWindowIncludeOperationTime': 'Include Operation duration in Time Window',
                '<ptv_dynamic_routing-label>': 'Use traffic patterns',
                '<base_url-label>': 'Base service URL',
                'areaOfControls': 'Area of control parameters',
                'printScheduleLineWrapEnable': 'Enable line wrap',
                'captionForTestButton': 'Use for sending test email to <i><ins>specified<br/>SMTP user<\/ins><\/i>',
                'sharingWorkEquallyEnabledNotice': 'This will increase the schedule cost. If "Among all available resources" is used then "Allow several runs for a vehicle per day" should be turned off.',
                'addressTypeOfNumber': 'Address TON',
                '<http_timeout>': 'Timeout for http request (ms)',
                'number': 'Short number-type',
                'acceptanceResourceLabel': 'Driver should acknowledge the assigned order within',
                'allowableTimeToBeAtPickup': 'Allowable time to be at pickup location (min)',
                'enableGeozonesReportTab': 'Geozones Report',
                'reportedStartTime': 'Arrival reported',
                'bothData': 'Both data',
                'block': 'In blocks',
                '<nominatim-label>': 'Nominatim.org',
                'enableDiagramView': 'Enable diagram view',
                'enableHistoricalTraffic': 'Apply traffic data',
                'enableClusterMicroserviceSchedulerLabel': 'Enable remote cluster microservice scheduler',
                'threadCountForDistanceCalculationLabel': 'Thread count for distance calculation before scheduling',
                'enableAutoSchedulingLabel': 'Enable auto scheduling',
                'planFactShowSearchOrders': 'Show "Search orders" page',
                'planFactActualDDUpdateReduceUsingEpsilon': 'Reduce waypoints using minimal distance between coordinates (meters)',
                'time_strategy': 'Time optimization',
                'planFactShowOperationalEnvironment': 'Show "Operational Environment" page',
                'selfImplementationWizard': 'Self implementation wizard on',
                'volumeLabel': 'Volume label',
                'rateWidgetText': 'Rate widget text',
                'plannedEndTime': 'Departure scheduled',
                'orderCancelReasons': 'Order Cancel Reasons',
                'planFactMaxTimeBetweenEnterAndDepartPickup': 'Allowable time between enter and depart for pickups (hours)',
                'orders': 'Order parameters',
                'planFactMaxTimeBetweenEnterAndDepartDrop': 'Allowable time between enter and depart for drops, works (hours)',
                'status': 'Status',
                'maxunitesMobileSignatureEnabled': 'Enable screen to signature',
                '<google_geocode_lang-label>': 'Google geocoding language',
                'singleAreaOfControlName': 'Single area of control name',
                'enableOrderTypesPanel': 'Order types',
                'planJobDuration': 'Scheduled job Duration',
                '<planning_time-label>': 'Time of day for traffic planning',
                'enableIncrementalSchedulingTab': 'Enable Incremental Scheduling Control',
                '<attempts_count_for_single_distance_calculation-label>': 'Attempts count for distance calculation single route before scheduling',
                'actorUser': 'User',
                'attachmentPhotoMedium': 'medium',
                'highlightTimeDelta': 'Backlight time recently planned orders, sec',
                '<client_name-label>': 'Client Name',
                'resourceCallsignEnabled': 'Show Callsign attribute for the resource',
                'smsProviderResponseTimeout': 'Provider response timeout (in seconds)',
                'enableDeliveryCostPerCustomerReportTab': 'Delivery Cost report per Customers',
                'geocoderFromApiKey': 'API import',
                'enableDistanceCalculationBeforeSchedulingLabel': 'Enable distance calculation before scheduling',
                'penaltyNearestPointAtTheEnd': 'Penalty for nearest point at the end',
                'table': 'In tables',
                'routingModes': 'Routing modes',
                'EnableActionsGroup': 'Enable notifications',
                'routingGuideGroup': 'Routing Guide (JTM)',
                'accountSmtpTestButton': 'Test',
                'tomtomAPIAccessKey': 'API access key',
                '<routing_matrix_url-label>': 'Routing Matrix service URL',
                'externalSystemEmulationRequestEnable': 'Enable external system signal emulation in system lifecycle events',
                'forward': 'forward',
                'wialonProperties': 'Wialon Client',
                'maxunitesMobileClient': 'Maxunites Mobile Client',
                'printSchedule': 'Print schedule',
                'enableConsolidatedReportTab': 'Enable consolidated report tab',
                'planFactPlannedRouteColor': 'Planned route color',
                'updateLandmarkOnArrival': 'Update customer location on arrival',
                'allowDriverToEditOrderItems': 'Allow the driver to edit order items',
                'allowMultiAoCtoPerformer': 'Performer can be assigned to several Areas of Control',
                'dropDurationRequired': 'Drop duration required',
                'maxForthcomingDaysForImportInAPI': 'Max Forthcoming Days For Import In API',
                'orderDropLocationEnabled': 'Order Drop location enabled',
                '<client_id-label>': 'Cllient id',
                '<ingit-label>': 'Ingit',
                'useNewManifest': 'Use a new version of driver manifest configuration',
                'capacityLabel': 'Capacity label',
                'enableRemoteInverseGeocoding': 'Enable External Inverse Geocoding',
                '<mobile_maxunites_xmpp_client-resource>': 'Default client resource name of performer JID (mc-client)',
                'printScheduleFooterEnable': 'Enable footer signature',
                'smtpIfMxSmtpMessageToAdmin': 'To configure your custom email server, please navigate to Settings -> Account Settings -> Email settings.',
                'onBoardTimeLimit': 'On board time limit for deliveries',
                'INTERSECTIONS': 'Minimization of intersections',
                'enableLandmarkTypeScreenTab': 'Landmark types',
                'enableRunReorderingLabel': 'Enable run reordering between schedules',
                'enableSwapSchedulingLabel': 'Enable swap scheduling',
                'timeLoadingLabel': 'Fixed loading duration',
                '<mobile_maxunites_xmpp_component-name>': 'XMPP component name',
                'printScheduleResponsibility': 'Information of liability',
                'breakesGroup': 'Breaks',
                '<reverse>': '',
                'customMessageText': 'Custom sms message',
                'extentedMultiComboModel': 'Extented multi combo model',
                'ordersBeforeNotify': 'Send e-mail notification before X not started orders',
                'savingsVehicleMatchingMode': 'Savings vehicle matching mode',
                'jobDuration': 'Job Duration',
                'pointType': 'Task',
                'swapSchedulesResequence': 'Swap schedules resequence',
                'allowableTimeToArriveToPickup': 'Allowable time to arrive to pickup location (min)',
                'endRouteGroup': 'End of the route',
                'planFactAllowableDelay': 'Track & trace allowable delay (minutes)',
                'planFactExportSchedule': 'Enable export schedule',
                'planFactMaxDaysInPastForDDUpdate': 'Maximum days in the past for distance&duration update',
                'emailAccountSettings': 'Email service',
                '<domain-label>': 'Domain',
                'CentroidLocalSearch': 'Centroid',
                'aggressiveWaitingTimeSuppression': 'Use aggressive waiting time suppression',
                'maxunitesMobileBarcodeEnabled': 'Enable screen to scanning barcode',
                'useAsTrackingResourceLabel': 'Use for tracking',
                'savingsRewindMode': 'Savings rewind mode',
                'customSmsEnable': 'Enable custom sms message',
                'enableChangingStartTimeSchedulingLabel': 'Enable changing start time scheduling',
                'planFactAutomaticUpdateOrderStatus': 'Use automatic update order status',
                'accountName': 'Account Name',
                'importInfoOrder': 'Import Info Order',
                'additionalTimePerVisit': 'Fixed time per address',
                'attachmentPhotoLow': 'low',
                'enableIterativeResequence': 'Enable iterative resequence',
                'multiMobileDestination': 'When deviceCode is present, send orders to',
                'useNewTracker': 'Use new Tracker',
                'accountSmtpEnabledSsl': 'SSL enabled',
                'routingDistanceLabel': 'Point sphere radius in meter',
                'reportFCEGroup': 'Fuel cost estimation properties',
                'nearestPointInTheBeginning': 'Plan nearest points in the beginning',
                'allowImprovedPlanningWithPriorities': 'Allow improved planning with priorities',
                'SwapLocalSearch': 'Swap',
                'tomtomCreateOrderLimitCount': 'Create order limit count',
                'enableMultidayOptimisationLabel': 'Enable multiday optimisation',
                'enableChangeResourceByCapacityLabel': 'Enable change resource by capacity',
                'enableDispatchSheetTab': 'Dispatch Sheet',
                'CSV': 'csv',
                'notifyDriverOnDetailsSent': 'Enable driver notification when order details are sent to mobile device',
                '<geoserver-group-label>': 'Geoserver parameters',
                'notifyOrderActionDeliveryStarted': 'Enable notification on delivery started',
                '<searchFieldAddressFormatHint>': 'Search field address format',
                'notifyOrderActionBeforeArrival': 'Enable notification on before arrival',
                'schedulingZoneMode': 'Territories planning mode',
                'allowSelectAoCsFromSeveralRDForPerformer': 'Possible to select Area of Controls from several Regional Divisions for Performer',
                'drivingTimeTolerance': 'Tolerance of planned driving time from the actual (in percent)',
                'smsTestMode': 'Use test mode for sms notifications',
                '<ptv_map_display_language-label>': 'Map display language',
                'enableCleanYearDayAvailabilities': 'Enable clean Year Day Availabilities',
                'planFactPrintSchedule': 'Enable print schedule',
                'RandomLocalSearch': 'Random',
                'enableLandmarksTab': 'Points of interest',
                'blockCompletingWithoutSignature': 'Prevent order completion before collecting a signature',
                '<data_is_short-label>': 'Divide meaningful values by coefficient',
                'breakType': 'Break type',
                'savingsV': 'Savings v parameter',
                'actualNumber': 'Actual sequence',
                'enableReportsTab': 'Reports',
                'orderItemFailReasons': 'Order item cancellation reasons',
                'timePeriodOfNonCompleted': 'Time period of non-completed runs storing, days',
                'hideRateDelivery': 'Hide rate delivery',
                'orderVolume': 'Volume',
                '<geobase-label>': 'Telogis Geobase',
                'colection': 'Collection',
                'password': 'Password',
                'enableDispatcherRole': 'Enable Dispatcher role',
                'connectionHost': 'Host',
                '<use_toll_roads-label>': 'Enable toll roads',
                '<use_custom_geo_address_form-label>': 'Use custom geo address form',
                'enableRoutingGuideTab': 'Routing Guide',
                '<path_to_temp_file-label>': 'Path to temporary file',
                'imperialDistanceUnit': 'Miles',
                '<cloudmade-label>': 'Cloudmade',
                'capacityIncrementValue': 'Increment capacity value',
                'enableDeliveryCostReportTab': 'Delivery Cost report',
                'planFactFilterExit': 'Do not consider departure from customer location if driver arrived to location, departed and returned back (by GPS) less than in X minutes',
                'dropDurationPerUnit': 'Variable duration per capacity unit delivery',
                'distanceTolerance': 'Tolerance of planned mileage from actual (in percent)',
                'userRoles': 'User Roles',
                'defaultTimeZone': 'Default Time Zone',
                'systemLogs': 'System logs',
                '<format-label>': 'Image format',
                'cutoffTimeLabel': 'Cut-off time',
                'enableAutoCommit': 'Enable \'schedule auto locking\' schedule',
                'actualEndTime': 'Departure Actual (GPS)',
                'capacityDecimalPrecision': 'Capacity decimal precision',
                'stopDetectionSpeed': 'Speed threshold for stops detection',
                '<region-label>': 'Region',
                '<mapquest-label>': 'MapQuest Maps',
                'accountSmtpFromEmail': 'Outgoing email',
                'exportControl': 'Export Control',
                'enableFilteringYearDayAvailabilities': 'Enable filtering year day availabilities',
                'planFactFactRouteColor': 'Fact route color',
                'FACT': 'Fact Forecasting',
                'hashForResetPasswordLifeTime': 'Hash for reset password life time, hours',
                'attachmentTransportPhotoWifi': 'Wi-Fi only',
                'planFactActualDDUpdateReduceUsingFactor': 'Reduce waypoints using reduction factor (value from interval [0,1])',
                'enableDeliveryDisciplinePerCustomerReportTab': 'Delivery discipline per customer',
                'etaProviderTypeLabel': 'ETA provider',
                'enableSnapshotCompressLabel': 'Enable snapshot compress',
                'timeLoadingByCapacityLabel': 'Variable loading duration (per unit)',
                'allowSelectAoCsFromSeveralRD': 'Possible to select Area of Controls from several Regional Divisions',
                'TomTomMobileProperties': 'TomTom Mobile Client',
                'RESOURCE': 'Resource optimization',
                '<provider_type-label>': 'Provider_type',
                'defaultResequenceMode': 'Default resequence mode',
                'systemId': 'System ID',
                'activeOnBoardTimeLimitCollection': 'Enable on board time limit for collections',
                'sourceAddress': 'Phone number',
                'drivesHaveRightToRejectOrders': 'Drivers have the right to reject incoming orders',
                'useCustomHeader': 'File\'s header is ignored',
                '<enable_batch_route_requests-label>': 'Enable batch route requests',
                '<yandex-label>': 'Yandex',
                'beforeOrderStartLabel': 'before order start',
                'accountSmtpUser': 'SMTP user',
                'activeOnBoardTimeLimit': 'Enable on board time limit for deliveries',
                '<layers-label>': 'Layers',
                'allowDriverToAddOrderItems': 'Allow the driver to add order items',
                '<map_key-label>': 'Map Key',
                '<routing_path_url-label>': 'Routing path service URL',
                '<geocoding_accuracy-label>': 'Geocoding Accuracy',
                'sortResourcesByCompatibleOrdersCount': 'Use the most specialized vehicles first',
                '<decarta-label>': 'Decarta',
                'factJobDuration': 'Actual job Duration',
                'serviceType': 'Service type',
                '<point_locator_url-label>': 'Point locator service URL',
                '<googlesatellite-label>': 'Google Satellite Maps',
                'enablePodSettings': 'Enable pod templates editor',
                'geocodingOnlyByPostcode': 'Use geocoding only by postcode',
                'maxunitesMobileAllowToPassInArbitraryOrder': 'Allow to pass jobs in arbitrary order',
                '<average_speed-label>': 'Average speed (km per hour)',
                'MILEAGE': 'Mileage optimization',
                '<reverse_geocoding_url-label>': 'Reverse geocoding service URL',
                'capacityUnits': 'Capacity units',
                'distanceMatrixUpdateTime': 'Time interval for updating distance matrix',
                'printScheduleTemplate': 'Print schedule template',
                'enablePerformerPerformanceReportTab': 'Performer Performance Report',
                'sharingWorkEqually_off': 'Off',
                '<use_shortest_route-label>': 'Use shortest route',
                '<api_key-label>': 'Client private key',
                '<here-label>': 'Here',
                'centroidRewindMode': 'Centroid rewind mode',
                'smtpMailSubject': 'Test email',
                'dynamic': 'Dynamic',
                'enableAdminRole': 'Enable Administrator role',
                '<use_highway-label>': 'Use highways when routing',
                'planDrivingTime': 'Scheduled driving Time',
                '<enable_cache-label>': 'Enable cache',
                '<mobile_maxunites_xmpp_domain>': 'Default domain name of performer JID (mobile-central)',
                'metricDistanceUnit': 'Kilometers',
                '<allow_segment_violations-label>': 'Allow segment violations',
                '<geobase_server_ip-label>': 'Servier Ip',
                'smsNotificationsGroup': 'Sms notifications',
                'performerData': 'Performer data',
                '<use-multiple-points-routing>': 'Use routing by multiple points',
                'planningStrategy': 'Planning strategy',
                'tryConsolidateSameSiteJobs': 'Consolidation strategy for same site jobs',
                'mobileAttachmentGroup': 'Mobile attachments',
                'accountSmtpPassword': 'SMTP password',
                'enableRemoteGeorouting': 'Enable External Georouting',
                'multidayOptimizationHorizon': 'Multiday optimisation horizon',
                'useAttributesLabel': 'Use attributes',
                'dispatcherCanEditSettings': 'Dispatcher can edit settings',
                'emailTestMessageText': 'E-mail service has been successfully configured.',
                'factMileage': 'Actual mileage',
                'updateOrderStateAutomatically': 'Update order state automatically by track & Trace',
                'lastVerificationWhen': 'Verified when',
                'sharingWorkEquallyEnabled': 'Route balancing',
                '<mobile_maxunites_xmpp_secret>': 'Secret key for connection to communication server',
                'enableImportOnSelectedDate': 'Enable import on a specific date',
                'actualStartTime': 'Arrival actual (GPS)',
                'enableStatusReportBasedActualization': 'Enable status report-based actualization',
                'centroidResequenceOnEveryStep': 'Optimization resequence on every step',
                'consolidationEnable': 'Enable orders consolidation',
                'vehicleTypes': 'Vehicle types',
                'enableOnTimeReportTab': 'On Time report',
                'extentedObjectTypeModel': 'Use relations between order and resource types',
                'allowableTimeToBeAtDrop': 'Allowable time to be at drop location (min)',
                'fromPlannedStartLabel': 'from the planned start',
                'System': 'System parameters',
                'attachmentTransportPhotoAlways': 'Mobile data and Wi-Fi (immediate upload)',
                'planFactAnalyzeTrackRange': 'Allowable time range to getting into a geo_zone (hours)',
                'planFactColumns': 'Track & trace columns',
                'orderDropTimeWindowEnabled': 'Order\'s Drop time tindow enabled',
                'enableResourcePosition': 'Enable resource position in scheduling',
                'planFactGroup': 'Track & trace',
                'savingsCorrectionByWindow': 'Savings correction by window',
                'usageWidgetType': 'Use the widget',
                'savingsMu': 'Savings mu parameter',
                'exportFileFormat': 'File format',
                'wialonEnableStatusSynchronization': 'Enable status synchronization',
                '<ptv_geocoding_country_locator-label>': 'Search addresses in the following country',
                'vehicleDefaultParams': 'Vehicle default params',
                'rateUsText': 'Order complete. Please rate us',
                '<custom_map_config-label>': 'JSON map config',
                'onboardingModeOn': 'Onboarding mode on',
                'planFactRadius': 'Area radius for Track&Trace control (meters)',
                'geocodingProvider': 'Geocoding Provider',
                '<progorod-label>': 'Progorod',
                'TIME': 'Time optimization',
                'geoRoutingProvider': 'Routing Provider',
                'REPORT': 'Report Forecasting',
                '<geocoding_url-label>': 'Geocoding service URL',
                'attachmentTransportType': 'Attachments upload mode',
                'tomtomUseDedicatedCredentials4Orders': 'Use dedicated credentials for sending Orders',
                'order_dynamic_account_config': 'Dynamic attributes',
                'fixedOperationDuration': 'Fixed time per order',
                '<timeout_on_request_for_single_route-label>': 'Timeout on request for single route (sec)',
                'tomtomEnableRequestsLogging': 'Enable logging http requests',
                'acceptableMinutesWaitingTime': 'Acceptable waiting time (minutes)',
                'exportGroup': 'Export parameters',
                'smtpSuccessTestEmail': 'Email was sent successfully.',
                'disableHeadersOnCSVExport': 'Disable headers in export',
                'sourceAddressTypeOfNumber': 'Source address TON',
                'attribute_schema_configuration': 'Attribute schema configuration',
                'tomtomEnableStatusSynchronization': 'Enable order status synchronization',
                'mapprovider': 'Map provider',
                '<projection-label>': 'Projection',
                'enableScreens': 'Enable screens',
                'dispatcherNotify': 'Enable dispatcher notification before the driver completes the run',
                'enableDeviceAlertManagementTab': 'Device Alert Management',
                'enableMultipleSendAttempts': 'Enable repeated sending mode',
                'enableCustomerServiceRole': 'Enable Customer Service role',
                'enablePerformerTypesPanel': 'Performer types',
                'tomtomCreateOrderTimeLimit': 'Create order time limit, sec',
                '<timeout_on_request_for_some_routes-label>': 'Timeout on request for some routes (sec)',
                'useCLPhoneNumber': 'Use customer location phone number for sms notifications',
                '<openstreetmap-label>': 'Open Street Map',
                '<do_data_compression-label>': 'Compress result data on server',
                'enableManualSchedulingLabel': 'Enable manual scheduling',
                'enableAoCScreenTab': 'Area Of Control',
                'collectionsTimeUnloadingByCapacityLabel': 'Variable unloading duration (per unit)',
                'planMileage': 'Scheduled mileage',
                'enableAutoResequencing': 'Enable auto resequencing',
                'enableGeoDirectionsTab': 'Geo directions',
                'snapshotDirectoryLabel': 'Snapshots directory',
                'enablePickupAndDelivery': 'Pickup and Delivery mode',
                'useJobPrioritiesBasedOnCompatibleResourcesCount': 'Plan jobs with stricter constraints first',
                '<mobile_maxunites_update_enabled>': 'Automatic updates',
                'hideHomeLocation': 'Hide Home Location on vehicle\'s edit forms',
                'sendDetailsLabel': 'Send order details to driver',
                '<ptv_eplosive_goods-label>': 'Avoid segments with explosive goods restrictions',
                '<ptv_max_truck_length-label>': 'Truck max length, cm',
                'updateLandmarkTurnOff': 'Turn off',
                'phone': 'Primary phone',
                'attachmentPhotoHigh': 'high',
                '<nokiahere-label>': 'NokiaHere Maps',
                'csvCustomCustomerLocationTemplateConfiguration': 'Customer location import template configuration',
                'actorSystem': 'System',
                '<mobile_maxunites_xmpp_port>': 'Communication server port (5275)',
                'reportFCEWeightTpl': 'Weight template',
                'operativeMonitoringEnable': 'Enable Operative Monitoring',
                'updateLandmarkAutomatically': 'Automatically',
                'serviceUrl': 'Service Url',
                'mobileClient': 'Mobile Client',
                'enableSuggestAllocations': 'Enable Suggest Allocations',
                'plannedNumber': 'Scheduled sequence',
                'sessionLifeTime': 'Session Life Time, minutes',
                'timeUnloadingByCapacityLabel': 'Variable operation duration (per unit)',
                '<google_geocode_region-label>': 'Google geocoding region',
                'smtpErrorTestEmail': 'Email was not sent. Check settings please.',
                '<google-label>': 'Google Maps',
                'capacity': 'Capacity',
                'vehicle': 'Vehicle',
                'orderHasCapacity': 'Order has a Capacity attribute',
                '<use_api_key-label>': 'Use work API',
                'notifyOrderActionFailedOrder': 'Enable notification on failed order',
                'enableSchedulingLabel': 'Enable scheduling',
                'screens': 'Show screens',
                'enableMobileWorkflow': 'Enable mobile workflow',
                'multiDropWindowsEnabled': 'Multi drop windows enabled',
                'lastVerificationByUserName': 'Verified by',
                'orderNameMaxLength': 'Order name max length (max: 64)',
                'allowToSetFuturePoint': 'Allow to edit the future availability points',
                'performer': 'Performer',
                'runPlanningGroup': 'Run planning',
                '<geobase_wsdl_location-label>': 'WSDL location',
                '<traffic_model-label>': 'Traffic model',
                'allow_manual': 'Allow manual allocation operations on Tracking page',
                'stubPlanFact': 'Stub for Track&Trace screen',
                'actorPerformer': 'Performer',
                'startingPeriodLabel': 'Driver should show the order as \'started\' within',
                'addLoadTimeToCostLabel': 'Add load time to cost of a run',
                'enableDailyRunsReportTab': 'Daily Runs report',
                'orderHasCapacityInSeats': 'Order has a Capacity In Seats attribute',
                '<map_id-label>': 'Map ID',
                '<geoserver-label>': 'Geo Server',
                'enableLocationWidget': 'Enable widget',
                'enableSendOrderDetailsByTimer': 'Send order details by timer',
                'maxunitesMobileFactCostEnabled': 'Enable set actual cost',
                'enableAlertsTab': 'Alerts',
                'enableRemoveScheduleByDefault': 'Enable removing by default',
                'allowUsingBalancingInAccount': 'Allow using route balancing in account',
                'allowMultiAoCtoDispatcher': 'Dispatcher can be assigned to several Areas of Control',
                '<default_vehicle_type-label>': 'Default Vehicle type',
                'pickupDurationRequired': 'Pickup duration required',
                'forecastingStrategyLabel': 'Forecasting Strategy',
                'maxunitesEnableBlockWithoutSignature': 'Enable preventing order completion before collecting a signature',
                'resourceGradeEnabled': 'Show Grade attribute for the performer',
                '<time_zone-label>': 'Time zone',
                'enableResequenceSchedulingLabel': 'Enable resequence',
                'onBoardTimeLimitCollection': 'On board time limit for collections',
                '<osrm5-label>': 'OSRM5',
                'etaProviderInternal': 'Internal Logic',
                'planFactFilterEnter': 'Do not consider arrival to customer location if driver was in location (by GPS) less than Y minutes',
                '<map24-label>': 'Navteq Map24',
                '<ptv_max_truck_axle_load-label>': 'Truck max axle load, kg',
                '<ulez_lines-label>': 'ULEZ lines',
                '<yournavigation-label>': 'YourNavigation.Org',
                'plannedStartTime': 'Arrival scheduled',
                'savingsResequenceOnEveryStep': 'Resequence on every step',
                'schedulingPriorityLabel': 'Scheduling priority',
                'scheduleExportTemplateConfiguration': 'Schedule export template',
                'buttonTestText': 'Test',
                '<allow_borders_crossing-label>': 'Allow borders crossing',
                'enableAutoDetailsSending': 'Enable auto sending of order details',
                'mileage': 'Mileage',
                'commitTimeLabel': 'Lock time',
                'enableLoadingResourcesReportTab': 'Fuel cost estimation',
                'volumeDecimalPrecision': 'Volume decimal precision',
                'plannedAddress': 'Location',
                'supportsSingleRegionalDivision': 'Supports single regional division',
                'useCustomCustomerLocationCsvTemplate': 'Use customer location import template',
                'smtpIfMxSmtpMessageToDisp': 'To configure your custom email server, please contact your Administrator account.',
                'tryUseTheMostSuitableResourceByAttributes': 'Use the most suitable resource by attributes first',
                'allowCompressSavings': 'Allow savings compression',
                'enableStrongCheckLocation': 'Refine unknown places',
                '<traffic-label>': 'Consider traffic',
                '<enable_single_attempts_for_distance_calculation-label>': 'Enable single attempts for distance calculation before scheduling',
                'enableCustomersTab': 'Customers',
                'accountSmtpPort': 'SMTP port',
                'useSpeedZone': 'Use Speed Zones for time estimations',
                'enableTextualGeocodingValidation': 'Textual geocoding validation',
                '<mobile_maxunites_xmpp_host>': 'Communication server IP',
                'schedulingModeLabel': 'Scheduling mode',
                'smtpIfMxSmtpMessageFirst': 'You are using the Maxoptra email server. ',
                'savingsLambda': 'Savings lambda parameter',
                'etaProviderGeoprovider': 'Real-time ETA from Geo provider',
                'needAnaliseSpeed': 'Need analise speed for stops detecting',
                'csvCustomOrderTemplateConfiguration': 'Order import template configuration',
                'enableMicroserviceSchedulerLabel': 'Enable new microservice scheduler',
                '<persisted_cache_message_size-label>': 'Size of message for sending to persisted cache',
                'LinearLocalSearch': 'Linear',
                '<ptv_hazardous_goods-label>': 'Avoid segments with hazardous goods restrictions',
                'defaultCustomerLocationTimeAvailable': 'Default availability time for customer location',
                'UniversalMobileProperties': 'Universal Mobile Client',
                'accountConfigurationUpdateError': 'The dynamic break values cannot be empty or zero',
                '<attempts_count_for_batch_distance_calculation-label>': 'Attempts count for distance calculation batch routes before scheduling',
                'enableAutoCutOff': 'Enable auto cut-off',
                '<geoserver-uri-label>': 'URI',
                'noticesUpdateInterval': 'Notices\' update interval (in milliseconds)',
                'connectionPort': 'Port',
                'locationWidgetBaseAddress': 'Widget location',
                'resource_strategy': 'Resource optimization',
                'useRoutingGuideLabel': 'Enable Routing Guide',
                'factDrivingTime': 'Actual driving Time',
                'destinationAddressNumberingPlanIndicator': 'Destination address NPI',
                'timeSendOrderDetailsByTimer': 'Send order details at',
                'activeScheduleOrders': 'Allow schedule orders forward',
                'AUTOMATIC': 'Automatic',
                'carrotQuestWidget': 'Use Carrot Quest widget',
                'security': 'Security',
                'replaceZeroWithCountryPhoneCode': 'Replace initial 0 with country phone code',
                'configurationUpdateSuccessful': 'Configuration has been successfully updated',
                'tomtomEnableTrackingReceive': 'Enable tracking replication',
                'collectionsTimeUnloadingLabel': 'Fixed unloading duration',
                'duringRouteGroup': 'During the route',
                'mileage_strategy': 'Mileage optimization',
                'XLS': 'xls',
                'extraTimeRouteInMinutesLabel': 'Add extra time to each trip',
                '<cache-storage-time-label>': 'Cache storage time (in days)',
                '<routes_batch_size_for_distance_calculation-label>': 'Routes batch size for distance calculation',
                'maxunitesMobileMapDisplayEnabled': 'Enable map displaying at Mobile UI',
                '<geocoding_key-label>': 'Geocoding Key',
                'resources': 'Resource parameters',
                '<urban_areas_avoidance_malus-label>': 'Avoid urban areas malus',
                'csvImportSeparator': 'Separator',
                '<ptv_max_truck_width-label>': 'Truck max width, cm',
                'beginningRouteGroup': 'Beginning of the route',
                '<mobile_maxunites_yandex_rsa_private_key>': 'Yandex RSA Private Key',
                '<restricted_roads-label>': 'Restricted roads'
            },
            'mx.app.core.termins.UserRoles': {
                'coordinator': 'Coordinator',
                'performer': 'Performer',
                'accountant': 'Magenta Accountant',
                'manager': 'Manager',
                'super_admin': 'Magenta Administrator',
                'admin': 'Account Administrator',
                'dispatcher': 'Dispatcher',
                'sales': 'Order Entry'
            },
            'mx.app.mobile.pda.terms.optionsScreen': {'sortByNumber': 'Sort jobs by number'},
            'mx.comp.PeriodField': {
                'milliseconds': 'milliseconds',
                'hours': 'hours',
                'seconds': 'seconds',
                'weeks': 'weeks',
                'minutes': 'minutes',
                'days': 'days'
            },
            'scheduling.order.failreason': {
                '<to_in>': 'to',
                '<scheduling_list_of_resources>': 'list of resources',
                '<matcher_was_unallocated_with_handle_matching>': 'was unallocated with handle matching',
                '<order_late_from_future_availability>': 'Order hasn\'t time to pickup from a start point',
                '<not_loaded_order>': 'not loaded Order',
                '<persist_error>': 'Exception occurred while saving planning results. Session could not be completed. Restart planning.',
                '<by>': 'by',
                '<is_successful>': 'is successful',
                '<matcher_job_not_matched>': 'order was not matched',
                '<log_drop_of_order>': 'drop of order',
                '<PrecedenceConstraintViolation>': 'Incorrect linked order sequence. The delivery must follow the collection',
                '<batch_scheduling_prepare_data>': 'Prepare data for scheduling',
                '<matcher_order_not_matched>': 'Order is not matched by reason:',
                '<matcher_resource_and_job_in_different_aoc>': 'Resource and order are in different Area of control',
                '<log_has_shifted_to_left>': 'has shifted to left',
                '<wrong_time>': 'wrong time',
                '<current_time>': 'Current time',
                '<engine_unallocated_order>': 'scheduler engine unallocate this order',
                '<excess_limit_configuration>': '',
                '<max_start_time_has_gone>': 'Max start time has gone',
                '<matcher_attributes_not_matched>': 'Attributes do not match:',
                '<journey_time>': 'journey time',
                '<matcher_order_intersect_deadheading_for_pickup>': 'Deadheading to pickup for order',
                '<matcher_intersect_with_schedule>': 'this job intersect schedule for job =',
                '<from>': 'from',
                '<fail_planning_order>': 'fail planning of order:',
                '<matcher_minut>': 'minutes',
                '<invalid_location>': 'Order has an error and can not be allocated: ',
                '<matcher_hours>': 'hours',
                '<loader_problem_not_calendar>': 'have no work calendar.\n',
                '<dest>': 'dest',
                '<log_has_been_shifted_by>': 'has been shifted by',
                '<scheduler_stopped_by_another_user>': 'Planning was stopped by another user.',
                '<resource>': 'Resource',
                '<not_found_aocs>': 'Area of control was not found for current user:',
                '<scheduling_not_matched_by_attributes>': 'Resources are not matched by attributes.',
                '<order>': 'Order',
                '<loader_problem_not_available_windows>': 'have no available windows.\n',
                '<excess_limit_hours_driving>': 'driving time',
                '<scheduling_attrs>': 'attrs',
                '<overdue>': 'being overdue, not loaded!',
                '<order_unallocated_by_reason>': 'Order has been unallocated by reason',
                '<matcher_do_not_put_in_window>': 'Order cannot be put in this resource available window =',
                '<matcher_is_unable_return1>': 'is unable return from drop of the',
                '<variants_order_havnt_time>': '',
                '<order_start_time>': 'Order start time',
                '<matcher_position_not_matched>': 'Resource position does not match by distance',
                '<order_max_start_time>': 'Order max start time',
                '<not_found_session_user>': 'User was not found for current session',
                '<log_daily_time_limit>': 'daily time limit',
                '<successfull_planning_resource>': 'to',
                '<hour>': 'hour',
                '<log_calc_eta>': 'calc ETA',
                '<loader_problem_not_availability_type>': 'have no availability type.\n',
                '<matcher_resource_work_day_need_expansion>': 'This assignment needs longer duty hours. {1} needed.',
                '<scheduler_stopped>': 'Scheduler was stopped by user:',
                '<matcher_order_driving_time>': 'order driving time',
                '<more>': 'more',
                '<no_allowed_routes_found>': 'No allowed routes are found to reach this order location',
                '<loader_performer_has_overnight>': 'Multiday driver shifts are currently not supported with multiday planning. All drivers must have availability hours that start and end on the same day. We are working on improving this.',
                '<try_again_later>': 'The server is busy. Please try again later',
                '<matcher_have_not_available_window>': 'resource has no available windows',
                '<time_end>': 'time end',
                '<schedule>': 'schedule',
                '<availability>': 'availability',
                '<loader_having_problems>': 'having problems, not loaded!',
                '<km_h>': 'km/h',
                '<unallocated_with_schedule>': 'Unallocated with schedule',
                '<loader_all_resources_not_worked>': 'All resources not working.',
                '<batch_scheduling_matrix_size_left>': 'Distance vectors left:',
                '<collection_before_last_delivery>': 'According to the settings, collection must be after the last delivery on this route',
                '<loader_problem_not_resources_for_planning>': 'No resources for planning.\n',
                '<matcher_order_intersect_next_orders>': 'order intersects next orders:',
                '<km>': 'km',
                '<route>': 'route',
                '<all>': 'All',
                '<loader_problem_not_performer>': 'not set Driver.',
                '<scheduling_not_matched_by_availability_time>': 'Resources are not available by time.',
                '<matcher_is_unable_return3>': '.\n The vehicle should end moving to the point at',
                '<source>': 'source',
                '<to_on>': 'to',
                '<empty_params>': 'Not all parameters were specified to run a command',
                '<time_start>': 'time start',
                '<dist>': 'distance',
                '<matcher_left>': 'left',
                '<scheduling_is_empty>': 'is empty',
                '<order_not_found>': 'The order list was changed. Scheduling was not finished. Restart planning.',
                '<order_overdue>': 'The order cannot be fulfilled within its time windows',
                '<excess_limit_driving_time>': 'Excess limit of driving time.',
                '<invalid_hash>': 'Some Runs were changed. Please reload screen',
                '<matcher_is_unable_to_start_the1>': 'is unable to start the',
                '<matcher_order_havnt_time_from_pickup_to_drop>': 'Order has no time from pickup to drop',
                '<single_mode_unallocate>': 'Unallocated in single mode',
                '<on>': 'on',
                '<speed>': 'speed',
                '<loader_problem_null_employed_time>': 'has work time',
                '<undo_does_not_possible>': 'Undo operation is not possible',
                '<matcher_is_unable_return2>': '.\n as availability hours are',
                '<time>': 'time',
                '<matcher_matched_successfully>': 'Resource matched successfully.',
                '<matcher_resource_not_contain_attribute>': 'Attributes do not match \n resource does not contain next attributes of order: {0}',
                '<matcher_days>': 'days',
                '<order_min_start_time>': 'Order min start time',
                '<the_orders_overdue>': 'All the orders are overdue',
                '<log_has_shifted_to_right>': 'has shifted to right',
                '<loader_performer>': 'Driver',
                '<matcher_employed_time_not_matched>': 'Resource has no work time',
                '<redo_does_not_possible>': 'Redo operation is not possible',
                '<matcher_is_unable_to_start_the2>': '.\n as availability hours are:',
                '<log_delta_for_this_day>': 'delta for this day',
                '<matcher_performer>': 'Performer',
                '<matcher_dont_match_by_capacity>': 'Order and resource do not match by capacity',
                '<matcher_not_match_by_available_window>': 'can not find resource available window, nearest window',
                '<matcher_order_intersect_deadhead_next_orders>': 'overlaps with orders :',
                '<time_in_journey>': 'travel time',
                '<in_past>': 'in past',
                '<all_notfixed_runs_were_unallocated>': 'All unfixed Runs were unscheduled',
                '<log_rest_of_eta>': 'rest of ETA',
                '<planning_already_running>': 'Concurrent scheduling prohibited',
                '<loader_problem_performer_without_vehicle>': 'without resource.',
                '<loader_problem_order_already_planned>': 'Order already planned for this resource.',
                '<matcher_is_unable_to_start_the3>': '.\n and\n the vehicle should start moving to the pickup point at',
                '<minute>': 'minute',
                '<home>': 'home',
                '<loader_vehicle>': 'Resources',
                '<matcher_limit_driving_time>': 'limit driving time',
                '<loader_problem_not_orders_for_planning>': 'No orders for planning.\n',
                '<jobs_planned_successfully>': 'Planned successfully {0} from {1}',
                '<consolidated>': 'consolidated',
                '<consignment_unsupported_configuration>': 'The consignment for this order has more than one pair of Pickup and Delivery orders. Please ensure only 1 collection and 1 delivery order linked with Pickup and Delivery link type are in the same consignment.',
                '<matcher_availability_time_not_matched>': 'Availability time does not match',
                '<earlier>': 'earlier',
                '<matcher_right>': 'right',
                '<log_last_planned_eta>': 'last planned ETA',
                '<loader_problem_null_speed>': 'have speed = 0.\n',
                '<terminated>': 'Scheduling process was manually terminated',
                '<matching>': 'Matching'
            },
            'mx.app.mobile.pda.terms.statuses': {
                'LATE_A_LOT': 'Late a lot',
                'DONE': 'Done',
                'LATE_15_MIN': 'Late 15 min',
                'inProgress': 'In progress',
                'start': 'Start',
                'DECLINED': 'Declined',
                'accept': 'Accept',
                'IN_PROGRESS': 'In progress',
                'LATE_1_HOUR': 'Late 1 hour',
                'LATE_30_MIN': 'Late 30 min',
                'fail': 'Fail',
                'late15': 'Late 15 min',
                'ACCEPTED': 'Accepted',
                'lateLot': 'Late a lot',
                'FAILED': 'Failed',
                'late1': 'Late 1 hour',
                'IDLE': 'Idle',
                'decline': 'Decline',
                'late30': 'Late 30 min',
                'complete': 'Complete',
                'UNALLOCATE': 'Unallocate'
            },
            'mx.app.core.units': {'line_distance': 'miles', 'speed': 'mph'},
            'mx.comp.AccountHostsList': {'host': 'Host'},
            'mx.app.widget.ScheduleTableGrid': {
                'NEW': 'New',
                'alertsWindow': 'Alerts for order',
                'WAITING_FOR_ACCEPTANCE': 'Waiting to be accepted',
                'driverTitle': 'Driver {0}',
                'log': 'Log',
                'logWindow': 'Log for',
                'commit': 'Commit',
                'noitems': 'No items',
                'estimatedDrivingTimen': 'Estimated driving time',
                'COMPLETED': 'Completed',
                'FAILED': 'Failed',
                'restOfDrivingTime': 'Remaining driving time',
                'ALLOCATED': 'Allocated',
                'STARTED': 'Started',
                'contact': 'Contact',
                'unallocate': 'Unallocate/ commit job',
                'details': 'details',
                'orderTitle': 'Order {0}',
                'orderName': 'Order name',
                'truckTitle': 'Resource {0}',
                'orderID': 'Order ID',
                'resource': 'Resource',
                'LATE_TO_COMPLETE': 'Late to complete',
                'dropLocation': 'Drop location',
                'COMMITTED': 'Sent',
                'pickupLocation': 'Pickup location',
                'endDateTime': 'End date time',
                'loading': 'Loading...',
                'UNALLOCATED': 'Unallocated',
                'unallocate2': 'Unallocate',
                'startDateTime': 'Start date time',
                'LATE_TO_START': 'Late to start',
                'comment': 'Comment',
                'actions': 'Actions',
                'WAITING_TO_BE_SENT': 'Waiting to be sent',
                'expenses': 'Expenses',
                'status': 'Status'
            },
            'mx.app.widget.AccountsEditForm': {
                'businessTemplate': 'Business template',
                'accountName': 'Account name',
                'city': 'City',
                'contactPerson': 'Contact person',
                'mobileClient': 'Mobile client',
                'salesChannel': 'Sales channel',
                'mapProvider': 'Map provider',
                'routingProviderFailSafe': 'Fail-safe routing provider',
                'accountHosts': 'Account hosts',
                'email': 'E-mail',
                'zip': 'ZIP / Postal code',
                'selectGeocodingProvider': 'Select a geocoding provider...',
                'urlRegExp': 'Account relative path must contain only letters, numbers and underscores',
                'geocodingProvider': 'Geocoding provider',
                'applicationTemplate': 'Application template',
                'contactDetails': 'Contact details',
                'suspended': 'Suspended',
                'url': 'Account relative path',
                'selectRoutingProviderFailSafe': 'Select a fail-safe routing provider',
                'billingDate': 'Billing date',
                'selectMapProvider': 'Select a map provider...',
                'dayOfMonth': 'day of each month',
                'phone': 'Phone',
                'streetAddress': 'Street address',
                'days': 'days',
                'payWithin': 'Pay within'
            },
            'RunPlaningAction': {
                'ALL_DISTRIBUTION_CENTRE_MULTI_DAY': 'For all distribution centres (Multi-day planning)',
                'ALL_DISTRIBUTION_CENTRE_SINGLE_DAY': 'For all distribution centres',
                'CURRENT_DISTRIBUTION_CENTRE_MULTI_DAY': 'For current distribution centre (Multi-day planning)',
                'CURRENT_DISTRIBUTION_CENTRE_SINGLE_DAY': 'For current distribution centre'
            },
            'mx.app.widget.Audit': {
                'cancel': 'Cancel',
                'display_changes': 'Displaying changes {0} - {1} of {2}',
                'history_of_changing': 'History of changing',
                'action_update': 'Update',
                'action_type': 'Action',
                'entity_name': 'Entity name',
                'changed_values': 'Changed values',
                'user_name': 'User name',
                'action_delete': 'Delete',
                'unknown': 'Unknown',
                'filter': 'Filter',
                'modification_date': 'Modification date',
                'property': 'Property',
                'show_range': 'Show',
                'display_empty': 'No changes to display',
                'action_create': 'Create',
                'new_value': 'New value'
            },
            'report': {'showOnMapButtonText': 'Show on map'},
            'com.magenta.maxoptra.schedulechart.stores': {
                'AllOrdersCommited': 'All orders are locked.',
                'CommitIsFailForOrdersWithIDs': 'Orders {0} are not locked'
            },
            'Ext.grid.GridView': {
                'columnsText': 'Columns',
                'sortAscText': 'Sort ascending',
                'sortDescText': 'Sort descending'
            },
            'mx.app.mobile.pda.terms.messages': {
                'notComplete': 'Previous task is not complete.',
                'noTasks': 'You have no tasks received. Please refresh the page.',
                'notCapable': 'Device is not capable of geo-location.'
            },
            'mx.app.widget.PolygonForm': {'search': 'Search', 'searchPosition': 'Search position', 'map': 'Map'},
            'mx.app.mobile.pda.terms': {
                'mins': 'mins',
                'min': 'min',
                'OperationStatusInconsistency': 'Unsupported operation: conditions were changed. Please go back and refresh the page.',
                'minutes': 'mins',
                'incorrectDateFormat': 'Incorrect date format',
                'noActivityHandler': 'Mobile client is not supported'
            },
            'mx.app.widget.ExpandableGridPanel': {
                'doYouWantToLeave': 'Do you want to close the form without saving changes?',
                'no': 'No',
                'deleteConfirmationDescritive': 'Are you sure you want to delete %b from the list?',
                'deleting': 'Deleting...',
                'deleteConfirmation': 'Are you sure you want to delete %a rows?',
                'yes': 'Yes',
                'confirmTitle': 'Confirmation',
                'loading': 'Loading...',
                'deleteConfirmationDeclinable': 'Are you sure you want to delete %a %b?'
            },
            'com.magenta.maxoptra.service.impl.google.google_locale': {
                'Italian': 'Italian',
                'Slovak': 'Slovak',
                'Russian': 'Russian',
                'Farsi': 'Farsi',
                'Hebrew': 'Hebrew',
                'Serbian': 'Serbian',
                'German': 'German',
                'Slovenian': 'Slovenian',
                'Swedish': 'Swedish',
                'Turkish': 'Turkish',
                'Ukrainian': 'Ukrainian',
                'Arabic': 'Arabic',
                'French': 'French',
                'Portuguese': 'Portuguese',
                'Indonesian': 'Indonesian',
                'Finnish': 'Finnish',
                'Hindi': 'Hindi',
                'Spanish': 'Spanish',
                'Thai': 'Thai',
                'Norwegian': 'Norwegian',
                'Basque': 'Basque',
                'Polish': 'Polish',
                'Lithuanian': 'Lithuanian',
                'Romansch': 'Romansch',
                'Latvian': 'Latvian',
                'Romanian': 'Romanian',
                'Bulgarian': 'Bulgarian',
                'Korean': 'Korean',
                'Japanese': 'Japanese',
                'Croatian': 'Croatian',
                'English': 'English',
                'Danish': 'Danish',
                'Vietnamese': 'Vietnamese',
                'Czech': 'Czech',
                'Hungarian': 'Hungarian',
                'Dutch': 'Dutch',
                'Greek': 'Greek'
            },
            'SchedulingSavingsRewindMode': {
                'ON_MERGE': 'On merge',
                'ON_SUCCESS_STEP': 'On success step',
                'NEVER': 'Never'
            },
            'mail.notify.driver': {
                'subject': 'Route scheduled on {0} at {1}',
                'body': 'Dear {0}!<br><br>Your route #{1} on {2} will start at {3} in vehicle registration {4}. <br>Departure time: {10}. <br>Your first {5} will be at {6}, address: {7}. <br>Your route comprises {8} order(s), the route ends at {9}.<br><br><br><span style="color: #666666; font-size: 8pt;">Your Maxoptra Team<\/span>'
            },
            'mx.app.widget.EditPanel': {
                'doYouWantToLeave': 'Do you want to close the form without saving changes?',
                'no': 'No',
                'yes': 'Yes',
                'save': 'Save',
                'warning': 'Warning',
                'confirmTitle': 'Confirmation',
                'information': 'Information',
                'history': 'History',
                'someFieldsAreWrong': 'Some fields are not filled out correctly.',
                'close': 'Close'
            },
            'mx.app.widget.assistant': {
                'runViewContent': 'A trip consists of 3 parts. Let\u2019s look at each part.',
                'kpiMileageContent': 'Total mileage of all the scheduled trips.',
                'planningContent': 'The system provides several ways of manual order scheduling: <br><ul> <li>from the list of unscheduled orders<\/li> <li>from the map.<\/li><\/ul> <br>Let\'s see how it works.',
                'endTitle': 'You\'ve finished interactive course!',
                'beginTitle': 'Welcome to the scheduling screen!',
                'endMultiPlanningFromMapContent': 'You have successfully scheduled several orders from the map!',
                'autoPlanningConfirmTitle': 'Automatic scheduling',
                'endMultiPlanningFromMapTitle': 'Scheduling several orders from the map',
                'autoPlanningBeginTitle': 'Automatic scheduling',
                'multiPlanningFromMapTakeTitle': 'Scheduling several orders from the map',
                'planningFromListDragTitle': 'Scheduling from the list',
                'orderViewContent': 'When you point to one of the orders in the trip you can see key parameters of the order: ID, type, weight etc. as well as the number of the order in the trip sequence. <br><br>By clicking the order number you open the order details card (without editing option).',
                'toTableViewContent': 'Please switch to the gantt view to proceed with the interactive course.',
                'journeyBottomContent': 'This line shows the cost of all planned trips for the vehicle for the day, estimated duration and the maximum permissible load weight for the particular vehicle.',
                'changeDayEndTitle': 'Calendar',
                'runHeaderTitle': '"Heading" of the trip',
                'beginContent': 'This screen is used for manual and automatic scheduling of your orders. <br> <br> To know more about the system, please follow the interactive tips. Use the left/right arrows to switch between tips.',
                'runFooterContent': 'Here you can see the time when the vehicle returns to the dispatch centre after finishing all the orders. <br><br>By pointing to this part of the trip you can also see its key parameters.',
                'endPlanningFromMapContent': 'Congratulations! You have successfully scheduled the order from the map.',
                'multiPlanningFromMapTakeContent': 'Press the Ctrl button on your keyboard and press and hold the left mouse button - this will activate selection area for the orders on the map. <br><br>Hold these buttons and extend the selection area to those orders which you need to schedule by dragging your mouse across the orders to be selected. <br><br>Release the left mouse button and then move the mouse pointer to the icon for one of the chosen orders and, holding the left mouse button again, drag the orders to the scheduling field.',
                'helpTitle': 'Help',
                'kpiMileageTitle': 'Total mileage',
                'kpiTimeTitle': 'Total time',
                'multiPlanningFromMapDragContent': 'Release selected orders on the chosen trip by releasing the left mouse button.',
                'journeyMiddleTitle': 'Vehicle indicators',
                'planningFromMapDragTitle': 'Scheduling from the map',
                'autoPlanningEndTitle': 'Results of Automatic scheduling',
                'journeyBaseTitle': 'Resourсes',
                'autoPlanningBeginContent': 'Press the automatic scheduling button.',
                'changeDayBeginTitle': 'Calendar',
                'planningFromMapTakeTitle': 'Scheduling from the map',
                'journeyBaseContent': 'This window shows all the vehicles and their drivers. Key information on each pair Vehicle+Driver  is highlighted.  <br><br>By clicking the vehicle number you open the vehicle details card. <br><br>By clicking the driver name   you open the driver details card.',
                'unplannedOrderCardTitle': 'Order details card',
                'changeDayEndContent': 'Choose the date to be planned.',
                'importBeginContent': 'To start working with the system you should add orders. Let\u2019s import some. Please download a sample import file - <a href="http://maxoptra.com/assets/orders.csv" download>orders.csv<\/a> and click \u201cImport from file\u201d icon.',
                'planningTitle': 'Manual scheduling',
                'toCtTitle': 'Assistant',
                'helpContent': 'For further information about the system press "Help".',
                'unplannedOrderTitle': 'The list of unscheduled orders',
                'runFooterTitle': '"Tail" of the trip',
                'toTableViewTitle': 'Assistant',
                'importEndContent': 'This window allows adding new orders to the system from an external csv file. To import orders click  «Browse» and choose the import file. Then click \u201cImport\u201d. You\'ve finished interactive course! Happy scheduling! <br> <a href="http://maxoptra.com/assets/orders.csv" download>orders.csv<\/a>',
                'mapTitle': 'Map',
                'planningFromListDragContent': 'Release the mouse button so that the order is placed on the trip.',
                'planningFromMapTakeContent': '<div class="planning">Put the mouse pointer on the order icon - <img src="../gt-commons/img/balun.png"> and, holding the left mouse button, drag the order to the scheduling field.<\/div>',
                'endPlanningFromListTitle': 'Scheduling from the list',
                'planningFromListTakeTitle': 'Scheduling from the list',
                'zoomChangeContent': 'Let\'s choose another scale for the time-table view.',
                'endPlanningFromListContent': 'Congratulations! You have successfully scheduled the order from the list.',
                'runViewTitle': 'Trip',
                'toCtContent': 'Please go to the scheduling screen.',
                'endContent': 'To repeat the course click <span class = "repeatTutorial">Repeat<\/span>. Happy scheduling!',
                'mapContent': 'You can see the location of any of your orders, view scheduled trips and correct or reschedule them manually.',
                'kpiTimeContent': 'Total time that your vehicles will spend on all the scheduled trips.',
                'autoPlanningConfirmContent': 'Press "Yes" to proceed scheduling.',
                'changeDayBeginContent': 'Scheduling in the past is not possible, please change the date. Click on the calendar icon.',
                'endPlanningFromMapTitle': 'Scheduling from the map',
                'kpiCostContent': 'Here you can see how much it will cost for the company to do all the trips in the time-table.',
                'orderViewTitle': 'Order details in the trip',
                'autoPlanningProcessTitle': 'Automatic scheduling',
                'importBeginTitle': 'Order import',
                'runHeaderContent': 'Here you can see the vehicle loading time. <br><br>When you point to this part of the trip you can see its key parameters: time of loading start, time of departure and time of return for the vehicle, trip duration and mileage as well as its expenses.',
                'planningFromMapDragContent': 'Place the order on the trip by releasing the mouse button to schedule it.',
                'planningFromListTakeContent': 'Put your mouse cursor on any order in the list and, holding left mouse button,  drag the order to the scheduling field.',
                'autoPlanningProcessContent': 'Please wait. The system is scheduling your orders. It may take some time.',
                'importEndTitle': 'Import window',
                'journeyBottomTitle': 'Vehicle indicators',
                'kpiCostTitle': 'Total cost of time-table',
                'unplannedOrderContent': 'In this list you can see all of the  orders which you need to schedule.',
                'zoomChangeTitle': 'Time-table view',
                'ganchartContent': 'Here you can manually schedule a route for any of your vehicles as well as view or modify the time-table created for them.',
                'ganchartTitle': 'Scheduling field',
                'unplannedOrderCardContent': 'By clicking the order number, you open the order details card. Here you can view and modify order parameters: ID, type, address, time intervals, weight etc.',
                'autoPlanningEndContent': 'When the scheduling is finished the system will inform you of the results. <br><br>Let\'s look at the key efficiency indicators of the schedule. Close the results window by pressing \u201cOK\u201d.',
                'multiPlanningFromMapDragTitle': 'Scheduling several orders from the map',
                'journeyMiddleContent': 'This line represents the distance that the vehicle will go during all planned trips for the day. <br><br>Here you can also see vehicle types and attributes and total weight of all orders planned for the particular vehicle for the day.'
            },
            'mx.app.core.auditProperties.Order': {
                'instructions': 'Additional instructions',
                'clientName': 'Client name',
                'log': 'Log',
                'destination': 'Destination',
                'contactPerson': 'Contact person',
                'source': 'Source',
                'type': 'Type',
                'jobStartTime': 'Job start time',
                'duration': 'Duration',
                'contactNumber': 'Contact number',
                'reportedStartTime': 'Reported start time',
                'durationPickup': 'Pickup duration',
                'minStartTime': 'Minimal start time',
                'cash': 'Cash',
                'createDate': 'Create date',
                'detailsSent': 'Details sent',
                'resource': 'Resource',
                'areaOfControl': 'Area of control',
                'priority': 'Priority',
                'tags': 'Attributes',
                'maxStartTime': 'Maximum start time',
                'name': 'Name',
                'comment': 'Comment',
                'reportedEndTime': 'Reported end time',
                'account': 'Account',
                'durationDrop': 'Drop duration',
                'jobEndTime': 'Job end time',
                'status': 'Status'
            },
            'mx.app.core.auditProperties.RegionalDivision': {
                'calendar': 'Calendar',
                'address': 'Address',
                'defaultAreaOfControl': 'Default area',
                'city': 'City',
                'latitude': 'Latitude',
                'timeZone': 'Time zone',
                'mandatory': 'Mandatory',
                'currentManager': 'Current Manager',
                'phoneNumber': 'Phone number',
                'polygon': 'Polygon',
                'name': 'Name',
                'region': 'Region',
                'account': 'Account',
                'longitude': 'Longitude'
            },
            'mx.app.widget.MapKeysGrid': {
                'clientName': 'Client name',
                'geocoding': 'For geocoding',
                'domain': 'Domain',
                'mapKeyTitle': 'Map key',
                'mapId': 'Map Id',
                'noitems': 'No items',
                'loading': 'Loading',
                'region': 'Region',
                'keyString': 'Key'
            },
            'com.magenta.maxoptra.ord.beans.service.impl': {
                'divisionNotFound': 'Regional division #{0} could not be found.',
                'emailNotFound': 'E-mail address could not be found.',
                'accountRelatedToLandmark': 'This account is related to one or more landmarks.',
                'aocByDispatcherNotFound': 'Dispatcher #{0} has no areas of control.',
                'divisionRelatedToOneOrMoreManagers': 'Division is related to one or more managers.',
                'tagRelatedToResource': 'Attribute "{0}" is related to one or more resources.',
                'resourceNotFound': 'Resource #{0} could not be found.',
                'yourPasswordIsWrong': 'You\'ve entered an incorrect current password. User\'s password has not changed.',
                'divisionShouldBeUnique': 'Division name should be unique within account.',
                'divisionRelatedToOneOrMoreAreas': 'Division is related to one or more areas.',
                'saleschannelShouldBeUnique': 'Sales channel with company name "{0}" already exists.',
                'accountShouldBeUnique': 'Account with name "{0}" already exists.',
                'saleschannelRelatedToAccount': 'This sales channel is related to one or more accounts.',
                'customerIdNotFound': 'Can\'t find customer #{0}.',
                'typeRelatedToResource': 'Type "{0}" is related to one or more resources.',
                'aocShouldBeUnique': 'Area of control with name "{0}" already exists.',
                'customerNotFound': 'Can\'t find customer for user #{0}.',
                'regionIdNotFound': 'Can\'t find region #{0}.',
                'tagShouldBeUnique': 'Attribute with name "{0}" already exists.',
                'typeRelatedToOrder': 'Type "{0}" is related to one or more orders.',
                'passwordIsEmpteOrDontMatch': 'Passwords are empty or don\'t match.',
                'aocNotFound': 'Area of control #{0} could not be found.',
                'typeRelatedToTag': 'Type "{0}" is related to one or more attributes.',
                'aocRelatedToDispatcher': 'This area is related to one or more dispatchers.',
                'modifyOrder': 'Cannot modify order with status "{0}".',
                'accountRelatedToDivision': 'This account is related to one or more regional divisions.',
                'namedResourceRelatedToPerformer': 'Resource "{0}" is related to one or more Driver.',
                'landmarkRelatedToResource': 'This landmark is related to one or more resources.',
                'resourceShouldBeUnique': 'Resource name should be unique within regional division',
                'landmarkShouldBeUnique': 'Landmark with current name already exists.',
                'abbreviationShouldBeUnique': 'Abbreviation with name "{0}" already exists.',
                'regionNotFound': 'Can\'t find region by division.',
                'namedResourceRelatedToOrder': 'Resource "{0}" is related to one or more orders.',
                'aocRelatedToOrder': 'This area is related to one or more orders.',
                'failedToDelete': 'Failed to delete.',
                'landmarkRelatedToOrder': 'This landmark is related to one or more orders.',
                'userAlreadyExistInSysDatabase': 'User already exists in system database, please choose another user name.',
                'accountRelatedToOrder': 'This account is related to one or more orders.',
                'aocRelatedToPerformer': 'This area is related to one or more performers.',
                'divisionRelatedToOneOrMoreDispatchers': 'Division is related to one or more dispatchers.',
                'orderNotFound': 'Order #{0} could not be found.',
                'tagRelatedToOrder': 'Attribute "{0}" is related to one or more orders.',
                'performerShouldBeUnique': 'Performer with name "{0}" already exists.',
                'typeShouldBeUnique': 'Type with name "{0}" already exists.',
                'loginShouldBeUnique': 'Login "{0}" is already in use.',
                'aocRelatedToResource': 'This area is related to one or more resources.',
                'accountRelatedToUser': 'This account is related to one or more users.'
            },
            'mx.userRoleControl.ManagerRoleControl': {
                'regionComboEmptyText': 'Select regional division...',
                'regionalDivision': 'Regional division'
            },
            'mx.app.core.holidays': {
                'newYear': 'New Year\'s Day',
                'russiaDay': 'Russia Day',
                'independenceDay': 'Independence Day',
                'veteransDay': 'Veterans Day',
                'springAndLaborDay': 'Spring and Labor Day',
                'thanksgivingDay': 'Thanksgiving Day',
                'earlyMay': 'Early May',
                'earlyMayBankHoliday': 'Early May Bank Holiday',
                'goodFriday': 'Good Friday',
                'easterMonday': 'Easter Monday',
                'defendersDay': 'Defender of the Fatherland Day',
                'laborDay': 'Labor Day',
                'christmas': 'Christmas Day',
                'columbusDay': 'Columbus Day',
                'martinLKingBirthday': 'Martin Luther King, Jr. Day',
                'boxingDay': 'Boxing Day',
                'victoryDay': 'Victory Day',
                'womensDay': 'International Women\'s Day',
                'presidentDay': 'Presidents\' Day',
                'summerBankHoliday': 'Summer Bank Holiday',
                'unityDay': 'Unity Day',
                'queensDiamondJubilee': 'Queen\'s Diamond Jubilee',
                'memorialDay': 'Memorial Day',
                'springBankHoliday': 'Spring Bank Holiday'
            },
            'mx.app.page.main.settings.AccountAndBilling': {
                'availableOn': 'Available on',
                'businessTemplate': 'Business template',
                'unsupportedExtension': 'Unsupported extension',
                'phoneRequired': 'Phone is a required field',
                'contactPersonRequired': 'Contact person is a required field',
                'contactPositionRequired': 'Contact position is a required field',
                'bthint': 'Company services area. Defined by Magenta Administrator.',
                'zipRequired': 'ZIP/Postal code is a required field',
                'warning': 'Warning',
                'uploading': 'Uploading',
                'industryNameRequired': 'Industry name is a required field',
                'zip': 'ZIP/Postal code',
                'cityRequired': 'City is a required field',
                'contactPosition': 'Contact position',
                'workCalendar': 'Work calendar',
                'history': 'History',
                'payWithinRequired': 'Pay within is a required field',
                'billingDate': 'Billing date',
                'streesAddress': 'Street address',
                'postalAddress': 'Postal address',
                'dayOfMonth': 'day of each month',
                'phone': 'Phone',
                'generalSettings': 'General settings',
                'payWithin': 'Pay within',
                'salesChannelIdRequired': 'Sales channel ID is a required field',
                'emailRequired': 'E-mail is a required field',
                'browse': 'Browse...',
                'updatedSuccessfully': 'Updated successfully',
                'accountNameRequired': 'Account name is a required field',
                'accountName': 'Account name',
                'city': 'City',
                'billingDateRequired': 'Billing date is a required field',
                'save': 'Save',
                'show': 'Show',
                'contactPerson': 'Contact person',
                'mobileClient': 'Mobile client',
                'error': 'Error',
                'salesChannelId': 'Sales channel ID',
                'streesAddressRequired': 'Street address is a required field',
                'email': 'E-mail',
                'industryName': 'Industry name',
                'urlRegExp': 'Account relative path must contain only letters, numbers and underscores',
                'hoursPerWeek': 'hours per week',
                'phoneError': 'Phone number must contain only digits',
                'accountLogo': 'Account logo',
                'emailError': 'E-mail is invalid',
                'clear': 'Clear',
                'someFieldsAreWrong': 'Some fields are not filled out correctly.',
                'contactDetails': 'Contact details',
                'url': 'Account relative path',
                'imageUploadHint': 'Upload your logo for the account. Only gif, jpg and png images are accepted. Max file size is 100Kb.',
                'primaryContact': 'Primary Contact',
                'billingParameters': 'Billing parameters',
                'days': 'days',
                'billingAddress': 'Billing address',
                'stateHolidays': 'State and bank holidays'
            },
            'mx.comp.EditingToolbar': {'add': 'Add', 'del': 'Delete'},
            'ord-ejb.import': {
                '<consignment-unknown-error>': 'Unknown consignment processing error.',
                '<landmark-not-unique-warning>': 'Landmark name "{0}" must be unique.',
                '<no-such-work-type-warning>': 'Not all orders types were found.',
                '<error-retrieving-location>': 'Customer location address "{0}" could not be found.',
                '<unknown-error>': 'Import failed',
                '<format-warn-account-not-found>': 'Account "{0}" is not found.',
                '<format-warn-regional-regionalDivision-is-not-found>': 'Regional division "{0}" is not found.',
                '<date-is-earlier-format-warning>': 'The "{0}" is earlier than the "{1}".',
                '<consignment-more-than-two-orders>': 'A consignment cannot include more than one pair of pickup and delivery.',
                '<geocoding-key-not-found>': 'Geocoding key for provider {0} is not found',
                '<error-details>': 'Error details',
                '<invalid-time-format-warning>': 'Invalid time format.',
                '<format-warn-invalid-priority-value>': '{0} {1} has an invalid priority value.',
                '<filed-coordinate-too-large>': 'Filed "{0}": {1} must be less then {2}.',
                '<schedulingZone-is-not-found>': 'Territory "{0}" is not found.',
                '<time-later-format-warning>': 'The Time To {0} should be later than the Time From {0}.',
                '<drivers-not-found-error>': '{0} was (were) not found.',
                '<geo-point-warning>': 'Do you mean {0}?',
                '<float-param-format-warning>': 'Parameter "{0}" has an invalid data format. The correct format is 00.000.',
                '<end-time-before-start-time>': '%gt.endTime% must be greater then %gt.startTime%',
                '<reference-allocated-order>': 'Order with reference #{0} is already planned. You are trying to update parameters not allowed to be changed. If you want to make a copy of this order, please press the "Save and continue" button. If you want to skip this order, please press the "Skip" button. If you want to change the order reference, please enter a new value in the "%gt.orderReference%" field and press the "Save and continue" button.',
                '<link-type-not-supported>': 'Consignment link type {0} is not supported.',
                '<vehicle-name-and-external-id-not-match>': 'The vehicle is not found by same name and external id: {0} - {1}',
                '<allocation-date-in-past>': 'The allocation date is in the past.',
                '<double-param-format-warning>': 'Parameter "{0}" has an invalid data format. The correct format is 00.00.',
                '<order-item-wrong-separator>': 'Item "{0}" could not be recognised.',
                '<format-warn-regional-areaOfControl-is-not-found>': 'Area of control "{0}" is not found.',
                '<row-field-planned-order>': 'Field "{0}": {1} is already exists in planned order.',
                '<format-warn-resource-is-required>': 'Resource is required.',
                '<invalid-file-format>': 'Invalid file format: \n Please check your file and try again',
                '<pickup-time-warning>': 'Pickup time is not defined.',
                '<invalid-time-windows-warn>': 'All time windows are empty. Format {0} expected.',
                '<field-order-reference-is-not-unique>': 'Field {0}: {1} does not have a unique order reference.',
                '<format-warn-already-exist>': '{0} {1} already exists. Skipping.',
                '<instruction-address>': 'Enter valid address or find it on the map.',
                '<access-denied>': 'Access denied',
                '<row-skipped-warning>': 'Line {0}.',
                '<saving-to-database-failed>': 'Saving to database failed because of errors',
                '<window-warning-before>': 'The start of the order time window is earlier than the start of the customer location time window.',
                '<invalid-time-window-warning>': 'Orders with operational window more than {0} {1} cannot be imported.',
                '<format-warn-invalid-stop-sequence-value>': 'Stop sequence "{0}" is incorrect. Expected values: First, Any, Last.',
                '<some-vehicles-match-name>': 'There are more than one vehicles with the name "{0}". Please select a unique name to allocate the order to. Alternatively, you can use the vehicleExternalID field instead',
                '<format-warn-invalid-date-format>': 'Parameter {0} has invalid date format. The format should be {1}.',
                '<can-not-parse-file>': 'Cant parse file',
                '<email_invalid>': 'This field should be an e-mail address in the format "xxxxxx@domain.com"',
                '<format-warn-userzone-is-not-found>': 'User zone "{0}" is not found.',
                '<format-warn-resource-is-not-found>': 'Resource "{0}" is not found.',
                '<order-reference-is-not-unique>': 'An order with reference "{0}" already exists - for {1} with status "{2}".',
                '<invalid-time-format-warn>': 'Field "{0}" is incorrect. Format {1} expected.',
                '<vehicleRequirementNotFound>': 'Vehicle requirement "{0}" not exists. Remove non existent requirements from importing list or add necessary requirements via settings and repeat import.',
                '<consignment-reference-already-used>': 'Consignment order has incorrect configuration. Scheduling cannot be processed.',
                '<order-item-wrong-brackets>': 'Name of item "{0}" could not be recognised. "{1}" is missing.',
                '<address-geocode-warning>': '{0} could not be located on the map.',
                '<vehicle-from-another-dc>': '%gt.vehicle% "{0}" belongs to another DC.',
                '<vehicle-not-found>': '%gt.vehicle% "{0}" is not found.',
                '<vehicles-can-not-be-import>': 'Vehicles can\'t be imported here. Use import at Vehicles screen to import resources',
                '<select-of-locations>': 'The customer location with the given address "{0}" and name "{1}" was not found. The following locations match either by name, address text or by geographic location. Please select one of them or create a new one.',
                '<invalid-date-format-warn>': 'Field "{0}" has an invalid date format. The correct format is {1}.',
                '<filed-coordinate-too-small>': 'Filed "{0}": {1} must be greater then {2}.',
                '<format-warn-there-is-no-landmark-type>': 'There is no landmark type "{0}".',
                '<customer-location-name-not-found>': 'Customer location "{0}" was not found.',
                '<format-warn-customer-location-not-found>': 'Customer location "{0}" was not found.',
                '<too-long-field>': 'Field "{0}": {1} is too long. Max {2} symbols.',
                '<error-prefix>': 'Import error.',
                '<format-warn-invalid-estimatedDrivingTime-value>': 'The value of element \'estimatedDrivingTime\' is not valid.',
                '<customer-location-name-is-not-unique>': 'Customer location name "{0}" is not unique. Provide another name, please.',
                '<window-warning-after>': 'The end of the order time window is later than the end of the customer location time window.',
                '<postcode-parse-warning>': 'Can not parse postcode {0}.',
                '<reference-order-not-unique>': 'Order with reference #{0} is already planned. If you want to make a copy of this order, please press the "Save and continue" button. If you want to skip this order, please press the "Skip" button. If you want to change the order reference, please enter a new value in the "%gt.orderReference%" field and press the "Save and continue" button.',
                '<positive-param-format-warning>': 'Parameter "{0}" must be positive number.',
                '<wrong-task>': 'Task "{0}" is invalid. Available tasks are "{1}" or "{2}". You can leave this field empty to create a {1}.',
                '<customer-location-address-not-found>': 'Customer location with address "{0}" was not found.',
                '<order-item-no-barcode>': 'No barcode is available for item "{0}".',
                '<consignment-reference-not-specified>': 'Consignment reference is mandatory if Consignment link type is specified.',
                '<long-param-format-warning>': 'Parameter "{0}" is not integer.',
                '<row-field-not-unique>': 'Field "{0}": {1} is not unique.',
                '<type-and-landmarks-can-not-be-import>': 'You haven\'t enough rights to import types or landmarks. Skipping them.',
                '<required-field-warning>': 'Field "{0}" is required.',
                '<create-new-location>': 'The customer location at "{0}" is not found. Please complete the form below to add a new customer location.',
                '<can-not-delete-old-resources>': 'Old resources can be deleted from resources screen only',
                '<unknown-csv-separator-in-settings>': 'Unknown separator is set in account settings. Please set comma or semicolon as separator for import.',
                '<format-warn-there-is-no-attribute>': 'The type "{0}" does not have attribute "{1}".',
                '<format-warn-there-is-no-type>': 'There is no type "{0}".',
                '<allocation-date-not-in-drop-windows>': 'The allocation date is outside of the order time windows.',
                '<work-type-is-empty-warning>': 'Work type is not defined.',
                '<link-type-not-specified>': 'Consignment Link type is mandatory if consignment reference is specified.',
                '<filed-coordinate-type-incorrect>': 'Parameter "{0}" is not float.',
                '<orders-can-not-be-import>': 'Orders can\'t be imported here. Use import at Orders screen to import orders',
                '<planning-failed>': 'An error occurred while allocating the loaded orders. Please try again. On repeat failure please contact support.',
                '<window-warning>': 'Order time window: {0} - {1}. Customer location time window: {2} - {3}'
            },
            'mx.app.page.main.settings.Orders': {
                'NEW': 'New',
                'filterCriteria': '',
                'headerName': 'Name',
                'filterBlank': 'All',
                'WAITING_FOR_ACCEPTANCE': 'Waiting to be accepted',
                'LATE_TO_COMPLETE': 'Late to complete',
                'COMMITTED': 'Sent',
                'filterBy': 'Filter by area:',
                'UNALLOCATED': 'Unallocated',
                'headerTypes': 'Types',
                'headerClient': 'Client',
                'COMPLETED': 'Completed',
                'FAILED': 'Failed',
                'ALLOCATED': 'Allocated',
                'LATE_TO_START': 'Late to start',
                'STARTED': 'Started',
                'headerPriority': 'Priority',
                'headerStatus': 'Status',
                'headerAttributes': 'Attributes',
                'WAITING_TO_BE_SENT': 'Waiting to be sent'
            },
            'com.magenta.maxoptra.s3_worker.properties.S3ApplicationConfig.S3Params': {
                'KEY_S3_ACCESS_KEY': 'S3 Access Id Key',
                'KEY_S3_REGION_KEY': 'S3 Region',
                'KEY_S3_BUCKET_NAME': 'S3 Bucket Name',
                'KEY_S3_SERVER': 'S3 Server',
                'KEY_S3_SECRET_KEY': 'S3 Secret Key'
            },
            'com.magenta.maxoptra.service.impl.ptv.time_zone': {
                'French_Polynesia': 'French Polynesia(UTC-09:00)',
                'Chicago': 'Chicago(UTC-06:00)',
                'New_York': 'New York(UTC-05:00)',
                'Vladivostok': 'Vladivostok(UTC+10:00)',
                'Kiev': 'Kiev(UTC+02:00)',
                'Moscow': 'Moscow(UTC+03:00)',
                'Los_Angeles': 'Los Angeles(UTC-08:00)',
                'Krasnoyarsk': 'Krasnoyarsk(UTC+07:00)',
                'Yakutsk': 'Yakutsk(UTC+09:00)',
                'Santiago': 'Santiago(UTC-04:00)',
                'Fernando_de_Noronha': 'Fernando de Noronha(UTC-02:00)',
                'Irkutsk': 'Irkutsk(UTC+08:00)',
                'Honolulu': 'Honolulu(UTC-10:00)',
                'Novosibirsk': 'Novosibirsk(UTC+06:00)',
                'London': 'London(UTC 00:00)',
                'Phoenix': 'Phoenix(UTC-07:00)',
                'Yekaterinburg': 'Yekaterinburg(UTC+05:00)',
                'Buenos_Aires': 'Buenos Aires(UTC-03:00)',
                'Samara': 'Samara(UTC+04:00)',
                'Greenland': 'Greenland(UTC-01:00)',
                'Paris': 'Paris(UTC+01:00)'
            },
            'gt.order.status': {
                'NEW': 'New',
                'DELIVERED': 'Delivered',
                'CLOSED': 'Closed',
                'DETAILS_SENDING': 'Details sending',
                'DELIVERY_ON_MOVE': 'Delivery on move',
                'PICKUP_STARTED': 'Pickup started',
                'PICKUP_ON_MOVE': 'Pickup on move',
                'COMMITTED': 'Accepted',
                'COMMITTING': 'Waiting to accept',
                'PICKUP_ARRIVED': 'Pickup arrived',
                'DELIVERY_ARRIVED': 'Delivery arrived',
                'FAILED': 'Failed',
                'DETAILS_SENT': 'Details sent',
                'DELIVERY_STARTED': 'Delivery started',
                'ALLOCATED': 'Allocated',
                'DELIVERY_FINISHED': 'Delivery finished',
                'PICKUP_FINISHED': 'Pickup finished',
                'DELIVERY_DEPARTED': 'Delivery departed',
                'PICKUP_DEPARTED': 'Pickup departed'
            },
            'mx.app.core.auditProperties.AccountBilling': {
                'zip': 'ZIP / Postal code',
                'country': 'Country',
                'streetMore': 'Street more',
                'city': 'City',
                'contactPosition': 'Contact position',
                'tate': 'State/Province',
                'contactDetails': 'Contact details',
                'billingDate': 'Billing date',
                'phone': 'Phone',
                'street': 'Street address',
                'contact': 'Contact',
                'payWithin': 'Pay within',
                'state': 'State/Province',
                'email': 'E-mail'
            },
            'mx.app.core.auditProperties.Driver': {
                'phoneNumber': 'Phone number',
                'name': 'Sign name',
                'regionalDivision': 'Regional division',
                'callSign': 'Call sign'
            },
            'mx.app.core.general': {'authentificateError': 'Authentificate time out'},
            'mx.app.core.navTitles': {
                'mx_app_page_main_dispatchSheet_Alerts': 'Alerts',
                'mx_app_page_main_settings_Landmarks': 'Landmarks',
                'mx_app_page_main_settings_AreasOfControl': 'Areas of control',
                'mx_app_page_main_Alerts': 'Alerts',
                'mx_app_page_main_settings_Settings': 'Settings',
                'mx_app_page_main_Reports': 'Reports',
                'mx_app_page_main_settings_Translations': 'Translations',
                'mx_app_page_main_settings_SalesChannel': 'Sales channel',
                'mx_app_page_main_settings_Resources': 'Resources',
                'mx_app_page_main_settings_Users': 'Users',
                'mx_app_page_main_DispatchSheet': 'Dispatch sheet',
                'mx_app_page_main_settings_AccountAndBilling': 'Account Settings',
                'mx_app_page_main_settings_Accounts': 'Accounts',
                'mx_app_page_main_dispatchSheet_Reports': 'Reports',
                'mx_app_page_main_settings_RegionalDivisions': 'Regional divisions',
                'mx_app_page_main_settings_Scheduling': 'Scheduling',
                'mx_app_page_main_Dispatching': 'Dispatching',
                'mx_app_page_main_settings_Orders': 'Orders',
                'mx_app_page_main_settings_Attributes': 'Attributes',
                'mx_app_page_main_dispatchSheet_ScheduleTable': 'Schedule Table'
            },
            'mx.app.core.termins.capacity': {'tons': 'tons', 'items': 'items'},
            'mx.app.core.auditProperties.Truck': {
                'typeTags': 'Type of attributes',
                'type': 'Type',
                'speed': 'Max speed',
                'priceForOneMile': 'Price for one mile',
                'eta': 'Eta',
                'referenceNumber': 'ID',
                'earningType': 'Earning type',
                'direction': 'Direction',
                'earning': 'Earning',
                'calendar': 'Calendar',
                'performer': 'Performer',
                'odometer': 'Odometer',
                'allowOvertime': 'Allow overtime',
                'jobs': 'Jobs',
                'showOnMap': 'Show on map',
                'transitTime': 'Transit time',
                'areaOfControl': 'Area of control',
                'home': 'Home',
                'tags': 'Attributes',
                'driver': 'Driver',
                'trackingInfo': 'Tracking info',
                'employedTime': 'Employed time',
                'grade': 'Grade',
                'name': 'Name',
                'overtime': 'Overtime',
                'regionalDivision': 'Regional division',
                'comment': 'Comment',
                'location': 'Location',
                'device': 'Assigned device',
                'status': 'Status'
            },
            'scheduling.order.failreason.<hour>[2.': {'*]': 'hours'},
            'mx': {
                'cancel': 'Cancel',
                'SODInvalidErrorMessage1': '"Send orders details to performer" should be less than "Schedule orders"',
                'sysError': 'System error',
                'SODInvalidErrorMessage3': '"Send orders details to performer" should be greater than "Cut-off time" + assigned order acknowledgement time',
                'driverShouldAcknowledgeTheAssignedOrderWithin': 'Performer should acknowledge the assigned order within',
                'inAdvance': 'in advance',
                'SODInvalidErrorMessage2': '"Send orders details to performer" should be greater than "Cut-off time"',
                'driverShouldShowTheOrderAsStartedWithin': 'Performer should show the order as \'started\' within',
                'systemError': 'System error',
                'resourceOptimization': 'resource optimization',
                'commitTime': 'Lock time',
                'price': 'Price',
                'weekDay': 'Week day',
                'schedulingSettingsIdNotDefined': 'Scheduling settings id is undefined!',
                'thursdays': 'thursdays',
                'someOrderLinkingThisOrderType': 'Following order types can not be deleted <br>because they are used by some orders:<br> {0}.',
                'regexText': 'Time must be in hh:mm format',
                'addressCantBeGeocoded': 'Address can not be geocoded',
                'exportBtn': 'Export schedule',
                'workSchedulesOverlap': 'Work schedules overlap',
                'importSuccess': 'Imported successfully',
                'sendOrderDetailsToDriver': 'Send order details to performer',
                'confirmation': 'Confirmation',
                'previousDay': 'Previous day',
                'unknownError': 'Unexpected error occurred',
                'saving': 'Saving...',
                'sunday': 'Sunday',
                'actioned_by': 'Actioned by',
                'recordsWithErrors': 'Following records have errors',
                'workingTill': 'Till',
                'driversRightReject': 'Performers have the right to reject incoming orders',
                'connFailed': 'Connection failed',
                'phone': 'Phone number',
                'intervalIncorrect': 'Interval incorrect',
                'jobFinish': 'To',
                'force': 'Force',
                'oneWeek': '+1 week',
                'wednesdays': 'wednesdays',
                'workStartTime': 'Work start time',
                'factCost': 'Actual cost',
                'intersectWithPreviousDay': 'Intersect with previous day',
                'status': 'Status',
                'saturday': 'Saturday',
                'clientName': 'Client Name',
                'save': 'Save',
                'strategyForSchedule': 'Strategy for schedule oplimization by',
                'contactPerson': 'Contact person',
                'skip': 'Skip',
                'manual': 'Manual',
                'vehicle': 'Vehicle',
                'workingSince': 'Since',
                'action_time': 'Date/Time',
                'requiredField': 'Field is required',
                're-import': 'Re-import',
                'filledIncorrectly': 'Not all the fields are filled out correctly',
                'wednesday': 'Wednesday',
                'automaticDispatchingHint': 'This mode allows the system to allocate orders to resources automatically.',
                'close': 'close',
                'monday': 'Monday',
                'SOInvalidErrorMessage1': '"Schedule orders" should be greater than "Commit time"',
                'stationLocation': 'Station Location',
                'twoWeeks': '+2 weeks',
                'address': 'Address',
                'connectionErrorTitle': 'Connection Error',
                'customerServiceLevel': 'customer service level',
                'forward': 'Save and continue',
                'more': 'MORE',
                'modeAndStrategy': 'Mode and strategy',
                'timeWindowInvalid': 'Job start time cannot be greater than job end time',
                'importSkippedTotal': '{total} record{end2} skipped',
                'thursday': 'Thursday',
                'fromThePlannesStart': 'from the planned start',
                'store': 'Send to error bin',
                'SOInvalidErrorMessage2': '"Schedule orders" should be greater than "Send orders details to performer"',
                'COTInvalidErrorMessage2': '"Cut-off time" should be less than "Send orders details to performer" - assigned order acknowledgement time',
                'COTInvalidErrorMessage1': '"Cut-off time" should be less than "Send orders details to performer"',
                'doubleField_invalidText': 'The value "{0}" must be in the format 00.00',
                'jobLocation': 'Job Location',
                'lowestCost': 'lowest cost',
                'processTerms': 'Process terms',
                'sameDay': 'Same day',
                'dateField_invalidText': 'Date must be in the format dd/mm/yyyy',
                'atLeastOneStrategyShouldBeChecked': 'At least one optimization strategy should be checked.',
                'connError': 'Connection Error',
                'integerField_invalidText': 'The value "{0}" must be integer',
                'jobWindow': 'Time window',
                'dueDate': 'Due date',
                'importExport': 'Import & Export',
                'replace': 'Replace',
                'AEInvalidErrorMessage1': 'Assigned order acknowledgement time should be less than "Send orders details to performer" - "Cut-off time"',
                'callSign': 'Call Sign',
                'importOf': 'of {0}',
                'emailField_invalidText': 'This field should be an e-mail address in the format "xxxxxx@domain.com"',
                'warning': 'Warning',
                'export': 'Export...',
                'scheduleOrders': 'Schedule orders',
                'importXML': 'Import XML',
                'timeFieldEmptyTextLabel': 'hh:mm',
                'saturdays': 'saturdays',
                'contactName': 'Contact name',
                'history': 'History',
                'createNew': 'Create new',
                'cutOffTime': 'Cut-off time',
                'importCSV': 'Import CSV',
                'volume': 'Volume',
                'more_details': 'More details',
                'breakTime': 'Break',
                'someLandmarkLinkingThisLandmarkType': 'Following landmark types can not be deleted <br>because they are used by some landmarks:<br> {0}.',
                'jobStart': 'From',
                'orderTypes': 'Order Types',
                'name': 'Name',
                'beforeOrderStart': 'before order start',
                'somePerformerLinkingThisPerformerType': 'Following performer types can not be deleted <br>because they are used by some performers:<br> {0}.',
                'CTInvalidErrorMessage1': '"Lock time" should be less than "Schedule orders"',
                'nextDay': 'Next day',
                'sendDetails': 'Send details',
                'updatedSuccessfully': 'Updated successfully',
                'import': 'Import...',
                'importXMLTitle': 'Import from XML-file',
                'logWindow': 'Log for',
                'importCSVTitle': 'Import from CSV-file',
                'manualDispatchingHint': 'This mode allows Dispatcher to perform manual allocation of orders to resources.',
                'back': 'Back',
                'description': 'Action',
                'update': 'Update',
                'schedulingMode': 'Scheduling mode',
                'manualMatching': 'Allow manual allocation operations on Tracking page',
                'mondays': 'mondays',
                'fridays': 'fridays',
                'timeField_invalidText': 'Time must be in the format hh:mm',
                'duration': 'Estimated duration',
                'importSuccessTotal': '{total} record{end2} imported successfully',
                'contactNumber': 'Contact number',
                'tuesdays': 'tuesdays',
                'friday': 'Friday',
                'ok': 'OK',
                'serverError': 'Server error',
                'cantGeocodeAddress': 'Address can not be geocoded: {0}',
                'workEndTime': 'Work end time',
                'dayAfterTomorrow': 'Day + 2',
                'comments': 'Description',
                'cost': 'Cost',
                'contactEmail': 'Contact E-mail',
                'importAllocatedTotal': '{total} record{end2} skipped as {end3} already scheduled',
                'maxLengthText': 'The maximum length for this field is {0}',
                'automatic': 'Automatic',
                'invalidText': 'The value in this field is invalid',
                'systemMatching': 'Allow system allocation of all events',
                'someFieldsAreWrong': 'Some fields are not filled out correctly.',
                'applyToAll': 'Apply to all',
                'sundays': 'sundays',
                'tuesday': 'Tuesday',
                'location': 'Location',
                'customer': 'Customer'
            },
            'mx.app.core.auditProperties.CustomerLocation': {
                'lastTimeUsed': 'Last time used',
                'latitude': 'Latitude',
                'description': 'Description',
                'additionalTimePerVisit': 'Additional time per visit',
                'secondaryPhoneNumber': 'Secondary telephone number',
                'type': 'Type',
                'rate': 'Rate',
                'referenceNumber': 'Customer reference number',
                'locationIsVerified': 'Location is verified',
                'useCount': 'Use count',
                'radius': 'Radius',
                'email': 'E-mail',
                'longitude': 'Longitude',
                'calendar': 'Work calendars',
                'pickupDurationPerUnit': 'Pickup duration per capacity unit',
                'refinedByArrival': 'Refined by arrival',
                'types': 'Vehicle requirements',
                'website': 'Website',
                'address': 'Address',
                'comments': 'Description',
                'contactName': 'Client name',
                'isValid': 'Is valid',
                'globalId': 'Global ID',
                'postcode': 'Postcode',
                'timeZone': 'Timezone',
                'dropDurationPerUnit': 'Drop duration per capacity unit',
                'tags': 'Tags',
                'fixedOperationDuration': 'Fixed operation duration',
                'accountId': 'Account ID',
                'phoneNumber': 'Primary telephone number',
                'regionId': 'Region ID',
                'name': 'Name',
                'preferDrivers': 'Preferred drivers',
                'region': 'Region',
                'favorite': 'Favorite',
                'account': 'Account',
                'customer': 'Customer'
            },
            'mx.plugin.Navigable': {'preventPageUnloadWarning': 'You have started making changes to the current form. If you navigate away from this form, your changes will be lost. <br/><br/> Proceed anyway?'},
            'Ext.form.Field': {'invalidText': 'The value in this field is invalid'},
            'mx.app.core.termins.stop_sequence': {
                'first_order': 'first',
                'last': 'Last',
                'last_order': 'last',
                'any': 'Any',
                'first': 'First'
            },
            'mx.comp.StateSelectCombo': {
                'emptyText': 'Select a state/province...',
                'fieldLabel': 'State/Province',
                'blankText': 'State/Province is a required field'
            },
            'mx.app.core.auditProperties.User': {
                'phoneNumber': 'Phone number',
                'globalId': 'Global ID',
                'name': 'Name',
                'mapType': 'Map type',
                'language': 'Language',
                'newPasswordHash': 'New password hash',
                'login': 'Login',
                'userRole': 'User role',
                'account': 'Account',
                'email': 'E-mail',
                'passwordHash': 'Password hash'
            },
            'mx.app.page.main.settings.RegionalDivisions': {
                'headerName': 'Name',
                'headerAddress': 'Address',
                'errorsUsersRDAlreadyOccupiedByUser': 'Selected regional division is already occupied by user'
            },
            'mx.app.widget.UsersEditForm': {
                'regionComboEmptyText': 'Select regional division...',
                'coordinator': 'Coordinator',
                'manager': 'Manager',
                'accountComboEmptyText': 'Select account...',
                'magentaAccountant': 'Magenta Accountant',
                'aocComboEmptyText': 'Select area of control...',
                'telephone': 'Telephone',
                'magentaAdministrator': 'Magenta Administrator',
                'areaOfControl': 'Area of control',
                'sales': 'Order Entry',
                'administrator': 'Account Administrator',
                'rolesNoCombinationErrorMsg': 'User must be assigned to at least one role',
                'regionalDivision': 'Regional division',
                'dispatcher': 'Dispatcher',
                'account': 'Account',
                'rolesFalseCombinationErrorMsg': 'One user can be either Magenta user or Account user, but not both.'
            },
            'com.magenta.time.formatter': {'ago': '{0} d {1} h {2} m {3} s ago'},
            'mx.app.widget.AlertsForm': {
                'orderNotStarted': 'Order is not started',
                'ordersNotBeenAccepted': 'Order must be accepted now',
                'dateRange': 'Date range',
                'resource': 'Resource',
                'ordersBeenUnallocated': 'Order is unallocated',
                'alertTypes': 'Alert types',
                'orderIsFailed': 'Order failed',
                'orderNotCompleted': 'Order is not completed',
                'ordersStartIsImpossible': 'Order start is impossible',
                'orderDeclined': 'Order is declined',
                'allValue': 'All',
                'applyBtn': 'Apply',
                'orderNotCommitted': 'Order is not locked',
                'ordersCrossWithUnavailabilityManual': 'Order cross with unavailability manual planning',
                'truckIsLate': 'Resource is late',
                'ordersCrossWithUnavailability': 'Order cross with unavailability',
                'noAllocationOptionsFound': 'No allocation options were found.<br>',
                'orderMustBeCommittedNow': 'Order must be locked now'
            },
            'mx.app.widget.MapDragingPlate': {'title': 'Landmarks editor'},
            'mx.app.page.main.ScheduleChart': {'futureAvailability': 'Future availability'},
            'SchedulingSavingsVehicleMatchingMode': {
                'BY_EMPTY': 'By empty',
                'WITH_SWAP': 'With swap',
                'OFF': 'Turned off'
            },
            'mx.app.widget.CustomIconsWindow': {
                'oneType': 'selected type',
                'addIconFor': 'Change icon of',
                'existingIcon': 'current icon for',
                'upload': 'Upload a new icon',
                'warnImagesWillBeReplaced': 'Warning: current icons for selected types will be replaced with new ones',
                'iconFile': 'new icon file',
                'removeIcon': 'Remove a custom icon for the type',
                'unsupportedExtension': 'Unsupported file extension',
                'windowTitle': 'Customize icons',
                'maximumDimensionError': 'Icon size should not be more than 32x32 pixels',
                'existingIcons': 'current icons for',
                'manyTypes': '%s selected types',
                'maximumFileSizeError': 'Icon file size should be less than 1,024 kb',
                'removeIcons': 'Remove custom icons for selected types',
                'uploading': 'Uploading',
                'warnImageWillBeReplaced': 'Warning: a current icon for the type will be replaced with a new one',
                'browse': 'Browse...',
                'minimumDimensionError': 'Icon size should not be less than 16x16 pixels'
            },
            'mx.app.mobile.pda.terms.pInfoPage': {
                'server': 'Server',
                'profile': 'Profile',
                'timeZone': 'Time zone',
                'login': 'Login',
                'version': 'Version',
                'platform': 'Platform',
                'currentLocation': 'Current location',
                'home': 'Home address'
            },
            'com.magenta.maxoptra.geotracking.cancel': {
                'incorrectAddress': 'Incorrect address',
                'customerAbsent': 'Customer is temporarily absent',
                'addressNotFound': 'Customer address not found',
                'technicalReasons': 'Unable to complete for technical reasons',
                'another': 'Other',
                'customerRetired': 'Customer is no longer at this address',
                'deliveryDelayed': 'Customer requested to reschedule',
                'refusedToObtain': 'Customer unwilling/unable to accept',
                'weatherConditions': 'Unable to complete due to weather conditions'
            },
            'mx.app.widget.Import': {
                'cancel': 'Cancel',
                'cancelLabel': 'Finish',
                'waitMsg': 'Uploading',
                'closeInfoWithAllocated': 'You would like to finish import procedure. {1} lines have been already added,  {0} skipped by user, {2} skipped as already scheduled. Proceed anyway?',
                'removeSchedule': 'Remove existing orders',
                'systemError': 'System error',
                'windowTitle': 'Import from file',
                'removeScheduleOnSelectedDateConfirmation': 'Are you sure you want to remove orders for',
                'importReport': 'Import report',
                'errorMsg': 'Please, select a file to upload',
                'importing': 'Importing... Please Wait...',
                'waitTitle': 'Please Wait...',
                'alreadyUsed': 'Import is already in progress for this account. Please try later.',
                'formatImportError': '{0} import Error',
                'importDateCannotBeEmpty': 'Import date can not be empty',
                'importLabel': 'Import',
                'additionalSettings': 'Additional settings',
                'importOnSelectedDate': 'Import orders for following date',
                'selectFile': 'Select a file for import',
                'closeInfo': 'You would like to finish import procedure. {1} lines have been already added,  {0} skipped. Proceed anyway?',
                'browse': 'Browse...',
                'xmlImportReport': 'Import report'
            },
            'mx.app.widget.ResourceHistoryGrid': {
                'date': 'Date/Time',
                'altitude': 'Altitude',
                'odometer': 'Odometer',
                'latitude': 'Latitude',
                'location': 'Location',
                'loading': 'Loading...',
                'speed': 'Speed',
                'direction': 'Direction',
                'longitude': 'Longitude'
            },
            'SchedulingSavingsResequenceMode': {
                'GLSP': 'GLSP',
                'TWO_OPT': '2-opt',
                'ENABLE_BOTH': 'Enable both',
                'OFF': 'Turned off'
            },
            'com.magenta.maxoptra.service.impl.ptv.default_vehicle_type': {
                'PEDESTRIAN': 'pedestrian',
                'EMERGENCY': 'emergency',
                'TRUCK_SLOW': 'truckslow',
                'BICYCLE': 'bicycle',
                'ARKONADA_TRUCK': 'arkonada-truck',
                'CAR_FAST': 'carfast',
                'TRUCK_FAST': 'truckfast',
                'CAR_SLOW': 'carslow',
                'DEFAULT': 'default',
                'DELIVERY': 'delivery'
            },
            'mx.app.mobile.pda.terms.logout_screen': {
                'no': 'No',
                'yes': 'Yes',
                'message': 'Do you really want to logout?'
            },
            'gis.errors': {
                '<bad-start-point>': 'Bad start point',
                '<unknown-address>': 'No corresponding geographic location could be found for the specified address. This may be due to the fact that the address is relatively new, or it may be incorrect',
                '<unknown-directions>': 'Unknown directions between the points mentioned in the query. This is usually because there is no route available between the two points, or because we do not have data for routing in that region',
                '<bad-finish-point>': 'Bad finish point',
                '<bad-key>': 'The given key is either invalid or does not match the domain for which it was given',
                '<success-result>': 'No errors occurred; the address was successfully parsed and its geocode has been returned',
                '<result-not-found>': 'NOT FOUND. RESULT IS NULL.',
                '<unavailable-address>': 'The geocode for the given address or the route for the given directions query cannot be returned due to legal or contractual reasons',
                '<bad-intermediate-point>': 'Bad intermediate point',
                '<bad-request>': 'A directions request could not be successfully parsed',
                '<geo-too-many-queries>': 'Unable to geocode address. Daily geocoding limit was exceed.',
                '<missing-query>': 'The HTTP q parameter was either missing or had no value. For geocoding requests, this means that an empty address was specified as input. For directions requests, this means that no query was specified in the input',
                '<server-error>': 'A geocoding or directions request could not be successfully processed, yet the exact reason for the failure is not known',
                '<isolated-intermediate-point>': 'Isolated intermediate point',
                '<isolated-start-point>': 'Isolated start point',
                '<isolated-finish-point>': 'Isolated finish point',
                '<aborted-request>': 'Status code indicating that the request was aborted due to a newer request',
                '<unknown-status>': 'Uknown Status'
            },
            'SchedulingZoneMode': {
                'USE_TERRITORY_GROUPS': 'Use groups of territories',
                'OFF': 'Without territories',
                'USE_TERRITORIES': 'Use territories'
            },
            'order.notify': {
                '<before_arrival_message_sms>': 'Your order [ORDER_NAME] will be delivered to [ADDRESS] at [ETA].',
                '<order_failed_message_email>': 'Hello. Your order [ORDER_NAME] was not delivered to [ADDRESS] at [ORDER_COMPLETE_TIME] due to the following reason -  [ORDER_FAIL_REASON]. Sorry for inconvenience.',
                '<n_days_before_arrival_message_sms>': 'Your order [ORDER_NAME] will be delivered to [ADDRESS] on [PLANNED_END_DATE] at [PLANNED_START_TIME].',
                '<n_days_before_arrival_subject>': 'Your order [ORDER_NAME] will be delivered on [PLANNED_END_DATE]',
                '<before_arrival_subject>': 'Your order [ORDER_NAME] will be in [ETA]',
                '<details_sent_subject>': 'Your order [ORDER_NAME] is due to be delivered on [PLANNED_END_DATE]',
                '<before_arrival_name>': 'N minutes before estimated time of arrival to customer',
                '<order_completed_subject>': 'Your order [ORDER_NAME] has been delivered',
                '<delivery_started_message_sms>': 'We are on the move to [ADDRESS]. Your order [ORDER_NAME] is next. We will be with you at [PLANNED_START_TIME].',
                '<n_days_before_arrival_message_email>': 'Hi! Your order [ORDER_NAME] will be delivered to [ADDRESS] on [PLANNED_END_DATE] at [PLANNED_START_TIME].',
                '<order_completed_message_sms>': 'Your order [ORDER_NAME] was delivered to [ADDRESS] at [ORDER_COMPLETE_TIME].',
                '<details_sent_message_sms>': 'Your order [ORDER_NAME] is due to be delivered to [ADDRESS] between [PLANNED_START_TIME_30_MIN_BEFORE] and [PLANNED_START_TIME_30_MIN_AFTER] on [PLANNED_END_DATE].',
                '<before_arrival_message_email>': 'Hi! Your order [ORDER_NAME] will be delivered to [ADDRESS] at [ETA].',
                '<delivery_started_subject>': 'Your order [ORDER_NAME] is next',
                '<order_completed_message_email>': 'Hi! Your order [ORDER_NAME] was delivered to [ADDRESS] at [ORDER_COMPLETE_TIME]',
                '<order_failed_subject>': 'We have been unable to deliver your order \u2013 Reference: [ORDER_NAME]',
                '<delivery_started_name>': 'Order delivery started',
                '<order_failed_message_sms>': 'Your order [ORDER_NAME] was not delivered to [ADDRESS] at [ORDER_COMPLETE_TIME] due to the  following reason -  [ORDER_FAIL_REASON].',
                '<delivery_started_message_email>': 'Hi! We are on the move to [ADDRESS]. Your order [ORDER_NAME] is next. We will be with you at [PLANNED_START_TIME].',
                '<details_sent_name>': 'Order details sent',
                'donotreply': '<br><span style="color: #666666; font-size: 8pt;">--<br>Your [ACCOUNT].<br>This is an automatically generated email, please do not reply.<\/span>',
                '<attach_pod_pdf>': 'Attach POD',
                '<details_sent_message_email>': 'Hi! Your order [ORDER_NAME] is due to be delivered to [ADDRESS] between [PLANNED_START_TIME_30_MIN_BEFORE] and [PLANNED_START_TIME_30_MIN_AFTER] on [PLANNED_END_DATE].'
            },
            'mx.app.core.auditProperties.AreaOfControl': {
                'polygon': 'Polygon',
                'regionKey': 'Region key',
                'currentDispatcher': 'Dispatcher',
                'name': 'Name',
                'regionalDivision': 'Regional division',
                'defaultForUnknownResources': 'Default for unknown resources'
            },
            'mx.comp.SearchOnMapField': {
                'aoc': 'aoc',
                'geocoding': 'geocoding',
                'resource': 'resource',
                'regionaldivision': 'division',
                'landmark': 'landmark'
            },
            'mx.app.widget.RegionalDivisionsForm': {
                'address': 'Address',
                'serviceArea': 'Service area',
                'addressError': 'Please, select an address',
                'timeZone': 'Time zone',
                'drivingInHours': '(in hours)',
                'timeOfOperations': 'Time of operations',
                'regionError': 'Please, select any region',
                'serviceAreaHint': 'Use the map icon to select on the map the area covered by this Regional division\'s services.',
                'ышеу': 'Site url',
                'driving': 'Daily Driving limit',
                'phone': 'Phone',
                'name': 'Name',
                'addressHint': 'Select the geographic area the Regional division is in',
                'position': 'Position',
                'region': 'Maps'
            },
            'mx.app.core.datetimehints': {
                'HH': 'hh',
                'MM': 'mm',
                'dd': 'dd',
                'hh': 'hh',
                'mm': 'mm',
                'ss': 'ss',
                'yy': 'yy',
                'yyyy': 'yyyy'
            },
            'com.magenta.maxoptra.web.api.stores': {'maxImageSize': 'Uploaded file must be less than 100Kb'},
            'mx.app.core.termins.priority': {'normal': 'Normal', 'high': 'High', 'midhigh': 'Medium'},
            'mx.app.core.auditProperties.SalesChannel': {
                'settings': 'Settings',
                'companyName': 'Company name',
                'contactPerson': 'Contact person',
                'channelId': 'Sales channel ID',
                'billing': 'Billing',
                'saleContactDetails': 'Sale contact details'
            },
            'mx.app.mobile.terms': {
                'notesLabel': 'Notes:',
                'welcomeTitle': 'Welcome to Mobile Client',
                'deleteLabel': 'Delete',
                'endLocationMaxSizeErrorMessage': 'End location should be no longer than 255 symbols.',
                'unavailable': 'Unavailable',
                'idleStatus': 'Idle',
                'locationsLabel': 'Locations:',
                'unavailabilityLabel': 'Unavailability',
                'eatScreenTitle': 'Estimated Availability Time',
                'lateALoStatust': 'Late a lot',
                'selectLandmarkErrorMessage': 'Please, select landmark.',
                'customerLabel': 'Customer:',
                'authorisationErrorMessage': 'Check input data.<br>No such login or password.<br>',
                'inactive': 'Inactive',
                'startLabel': 'Start:',
                'allStatuses': 'All',
                'validateError': 'Input Date Error',
                'orderInfoScreen': 'Order info',
                'endLabel': 'End:',
                'loginLable': 'Login:',
                'serviceUnavailabilityMessage': 'Service is not available. Please try again later.',
                'unavailabilityType': 'Unavailability',
                'toLabel': 'To',
                'lateInAnswerErrorMessage': 'You haven`t answer in time.<br/>This order was uncallocated from you.<br>',
                'datesEqualityErrorMessage': 'Start date can`t be equal end date.',
                'cancelLabel': 'Cancel',
                'checkInputDataMessage': 'Check input data.',
                'eatHours': 'Hours',
                'unallocateStatus': 'Unallocated',
                'driverInfoScreen': 'Driver info',
                'emptyEndLocationErrorMessage': 'End location parameter can`t be empty.',
                'notesMaxSizeErrorMessage': 'Notes should be no longer than 255 symbols.',
                'scheduleScreen': 'My schedule',
                'logoffLabel': 'Logoff',
                'acceptationError': 'Acceptation Error',
                'eatArrivalText': 'Please, enter estimated date of arrival',
                'resourceStatus': 'Resource status',
                'selectAllStatuses': 'Select all',
                'authorisationError': 'Authorisation Error',
                'timeMaxErrorMessage': 'Time can`t be greater then 24:00.',
                'startDateEarlierThenNowErrorMessage': 'Start date can`t be earlier then current date.',
                'historyLabel': 'History',
                'typeLabel': 'Type',
                'filterLabel': 'Filter',
                'errorLabel': 'Error',
                'passwordLable': 'Password:',
                'okLabel': 'OK',
                'eatText': 'Please, enter estimated time of availability',
                'selectLandmarkLabel': 'Select landmark',
                'declinedStatus': 'Declined',
                'destinationLabel': 'Destination:',
                'late30minStatus': 'Late 30 min',
                'newJobScreen': 'New Job',
                'waiting': 'Waiting',
                'deleteUnScreenTitle': 'Delete unavailability',
                'eatMinutes': 'Minutes',
                'sourceLabel': 'Source:',
                'acceptedStatus': 'Accepted',
                'myInfoLabel': 'My info',
                'myStatusScreen': 'My Status',
                'deleteUnText': 'Do You really want to delete this unavailability?',
                'backLabel': 'Back',
                'unavailability': 'Unavailability',
                'endLocationLabel': 'End location:',
                'fromLabel': 'From',
                'noLandmarksFound': 'No landmarks found',
                'dispatcherLabel': 'Dispatcher:',
                'noTypeSelected': 'You must select one or more types of instructions.',
                'startDateMaxErrorMessage': 'Start date can`t be greater then end date.',
                'addUnavailablePeriodScreen': 'Add unavailable period',
                'broken': 'Broken',
                'idle': 'Idle',
                'landmarkLabel': 'Landmark:',
                'performing': 'Performing',
                'backToMainScreen': 'Back to main screen',
                'onRoute': 'On route',
                'intersectErrorMessage': 'You tried to create unavailabilty interval, which overlaps with order.',
                'late15minStatus': 'Late 15 min',
                'expiredDateMessage': 'Your authorisation data expired.<br>Please relogin.',
                'refreshLabel': 'Refresh',
                'historyFilterScreen': 'History filter',
                'late1hourStatus': 'Late 1 hour',
                'enterButtonLabel': 'Enter'
            },
            'mx.comp.GeoTextField': {'pointArea': 'Draw area (polygon) on map'},
            'mx.app.mobile.pda.terms.menuScreen': {
                'logout': 'Logout',
                'addUnav': 'Add Unavailability',
                'options': 'Options',
                'history': 'History',
                'info': 'Info'
            },
            'errors.user': {'UserCannotHaveMagentaAndAccountRoles': 'User cannot have Magenta and Account user roles at the same time'},
            'mx.app.widget.GreetingVideoWindow': {
                'titleTutorial': 'Welcome to Maxoptra \u2014 online routing and scheduling solution',
                'skipBtn': 'Skip',
                'titleUpdate': 'What\'s new in the latest Maxoptra update'
            },
            'mx.comp.WeekField': {
                'sunday': 'Sunday',
                'saturday': 'Saturday',
                'tuesday': 'Tuesday',
                'friday': 'Friday',
                'thursday': 'Thursday',
                'wednesday': 'Wednesday',
                'holiday': 'Holidays',
                'monday': 'Monday'
            },
            'mx.app.page.main.dispatching.ResourceSchedule': {'title': 'Resource schedule for {0}'},
            'com.magenta.maxoptra.geotracking.orderItem.failReason': {
                'other': 'Other',
                'damaged': 'Damaged',
                'refusedToAccept': 'Refused to accept',
                'wrongItem': 'Wrong item'
            },
            'mx.app.widget.DriverEditForm': {
                'breakShift': 'Break can be automatically shifted by',
                'availableOn': 'Available on',
                'uiLanguage': 'Interface language',
                'employedAndOvertimeHoursSumWrong': 'Work time and allowed overtime hours in total must not exceed 168 h',
                'availability': 'Availability',
                'login': 'Login',
                'employed': 'Employed',
                'vehicle': 'Vehicle',
                'allowedOvertime': 'Allowed overtime',
                'availabilityType': 'Service type',
                'password': 'Password',
                'selectVehicle': 'Select vehicle',
                'spinnerMinValue': 'min value: {0}',
                'road': 'OTR',
                'warnSettingCanBeOverriden': '* The Resource Availablity setting can be overriden by Account.',
                'currentUserTimezone': 'Current user timezone',
                'callsign': 'Callsign',
                'availabilityTimeZone': 'Availability time zone',
                'perDay': 'per day',
                'email': 'E-mail',
                'regionComboEmptyText': 'Select depot...',
                'hoursPerWeek': 'hours per week',
                'minutes': 'minutes',
                'drivingLimit': 'Driving limit',
                'aocComboEmptyText': 'Select distribution centre...',
                'spinnerMaxValue': 'max value: {0}',
                'phoneNumber': 'Phone number',
                'daily': 'P&D',
                'grade': 'Grade',
                'homeLocation': 'Station location',
                'name': 'Name',
                'gradesComboboxHint': 'Define the priority of customers the resource is allowed to provide services for (highest allowed).',
                'comment': 'Comment',
                'spinnerValueShouldbeNumber': 'this field must contain a number'
            },
            'mx.action': {
                'RESOURCE_PICKUP_ON_MOVE_ACTION': 'Pickup order started',
                'RESOURCE_PICKUP_ARRIVED_ACTION': 'Arrived at pick up location',
                'PICKUP_FINISHED_ACTION': 'Pick up finished',
                'COMMITTING': 'Lock',
                'FREE_ACTION': 'Free',
                'DELIVERY_STARTED_ACTION': 'Delivery started',
                'LUNCH_TIME_ACTION': 'Lunch time',
                'DELIVERY_ON_MOVE_ACTION': 'Delivery order started',
                'RESUMED_ACTION': 'Resumed',
                'RESOURCE_DELIVERY_STARTED_ACTION': 'Delivery started',
                'NOTIFY': 'Notify customer via SMS',
                'RESOURCE_DELIVERY_ON_MOVE_ACTION': 'Delivery order started',
                'FAILED': 'Failed',
                'SEND_DETAILS': 'Send details',
                'RESOURCE_PICKUP_FINISHED_ACTION': 'Pick up finished',
                'PICKUP_DEPARTED_ACTION': 'Departed from pick up location',
                'RESOURCE_DELIVERY_DEPARTED_ACTION': 'Departed from delivery location',
                'DONE': 'Done',
                'BROKEN_ACTION': 'Broken',
                'MOVE_TO_TANK_UP_ACTION': 'Move to tank',
                'PICKUP_ON_MOVE_ACTION': 'Pickup order started',
                'COMMITTED': 'Accept',
                'UNCOMMIT': 'Unlock',
                'DELIVERY_DEPARTED_ACTION': 'Departed from delivery location',
                'DECLINE': 'Decline',
                'RESOURCE_PICKUP_STARTED_ACTION': 'Pick up started',
                'IN_PROGRESS': 'In progress',
                'RESOURCE_PICKUP_DEPARTED_ACTION': 'Departed from pick up location',
                'ARRIVED_TO_BASE_ACTION': 'Arrived to base',
                'DELIVERY_ARRIVED_ACTION': 'Arrived at delivery location',
                'DETAILS_SENT': 'Details sent',
                'SUSPENDED': 'Suspended',
                'PICKUP_STARTED_ACTION': 'Pick up started',
                'RESOURCE_DELIVERY_ARRIVED_ACTION': 'Arrived at delivery location',
                'DELIVERY_FINISHED_ACTION': 'Delivery finished',
                'CANCEL_SEND_DETAILS': 'Cancel send details',
                'PICKUP_ARRIVED_ACTION': 'Arrived at pick up location',
                'UNALLOCATE': 'Unallocate',
                'SUSPENDED_ACTION': 'Suspended'
            },
            'mail.remember': {
                'subject': 'Password recovery',
                'body': 'Hi {0}! <br> You recently requested to reset you password for your {1} Maxoptra account. <br><br> Clink the link to reset the password: <br><br> {2} <br><br> If you did not request a password reset, please ignore this email or contact us to let us know. This password reset link is valid only for the next {3} hours. <br>Best regards, <br> Your Maxoptra team'
            },
            'mx.app.mobile.pda.terms.screenNames': {'homeScreen': 'Home screen'},
            'mx.app.core.auditProperties.Account': {
                'template': 'Business template',
                'clearLogo': 'Clear logo',
                'contactPersonPosition': 'Contact person position',
                'geocodingProvider': 'Geocoding provider',
                'contactPerson': 'Contact person',
                'deviceKey': 'Device key',
                'salesChannel': 'Sales channel',
                'contactDetails': 'Contact details',
                'suspended': 'Suspended',
                'billing': 'Billing',
                'mapProvider': 'Map provider',
                'workCalendars': 'Work calendars',
                'availableTime': 'Available time',
                'schedulingSettings': 'Scheduling settings',
                'invoices': 'Invoices',
                'name': 'Account name',
                'accountMainSettings': 'Account main settings'
            },
            'mx.app.widget.AlertsGridPanel': {
                'NOT_ALLOCATED': 'Not allocated',
                'UNALLOCATED_CUT_OFF_TIME': 'Unallocated cut off time',
                'truckTitle': 'Resource {0}',
                'resource': 'Resource',
                'NOT_STARTED': 'Not started',
                'LATE_TO_COMPLETE': 'Late to complete',
                'UNAVAILABILITY': 'Unavailability',
                'noitems': 'No items',
                'loading': 'Loading...',
                'type': 'Type',
                'DECLINED': 'Declined',
                'noResource': 'no resource',
                'jobID': 'Order ID',
                'START_IMPOSSIBLE': 'Start is impossible',
                'FAILED': 'Failed',
                'NOT_ACCEPTED': 'Not accepted',
                'LATE_TO_START': 'Late to start',
                'time': 'Time',
                'orderTitle': 'Order {0}',
                'NOT_COMMITTED_MANUAL': 'Not accepted manual',
                'NOT_COMPLETED': 'Not completed',
                'parameters': 'Parameters',
                'NOT_COMMITTED_NO_OPTIONS': 'Not accepted no options'
            },
            'gt': {
                'contactDataGroup': 'Contact information',
                'useFiasAddressPreprocessor': 'Use FIAS address preprocessor',
                'limitOnGetVehicles': 'Limit on get vehicles',
                'mapprovider': 'Map Providers',
                'mobileClientsTab': 'Mobile Clients',
                'targetLocation': 'Target Location',
                'type': 'Type',
                'limitOnImportZones': 'limit on import zones',
                'limitOnLockSchedules': 'Limit on lock schedules',
                'limitOnSavingPerformers': 'Limit on saving performers',
                'restAPIConfigurationGroup': 'Rest API Configuration',
                'limitOnDeletingOrders': 'Limit on deleting orders',
                'planRouteLoader': 'Plan route loading...',
                'printingTab': 'Printing',
                'limitOnAssignPerformersToVehicles': 'Limit on assign performers to vehicles',
                'accountDistanceUnitLabel': 'Distance units',
                'orderColumnsScheme': 'Scheme of order\'s columns in table',
                'limitOnImportVehicleTypes': 'limit on import vehicle types',
                'runScriptBeforeImport': 'Run script before import',
                'enableFuelPricesTab': 'Fuel prices screen',
                'enableHistoricalTraffic': 'Use historical traffic',
                'importTab': 'Import',
                'limitOnValidationTypesAttributes': 'Limit on validation types attributes',
                'limitApiSlotBooking': 'Limit on slot booking through API',
                'limitOnLogout': 'Limit on logout',
                'suggestionsEnabled': 'Suggestions enabled',
                'lastActiveStage': 'Last Actual Location',
                'orderCollectionHue': 'Hue of collection marker',
                'limitOnImportVehicles': 'Limit on import vehicles',
                'limitOnImportTypesAttributes': 'Limit on import types attributes',
                'limitOnApiSchedulingStart': 'Limit on start scheduling through API',
                'sendPODImage': 'Send POD image',
                'limitOnExportAllocations': 'Limit on export allocations',
                'limitOnSavingOrders': 'Limit on saving orders',
                'limitOnExportPerformers': 'Limit on export performers',
                'limitOnImportSchedules': 'Limit on import schedules',
                'latitude': 'Latitude',
                'showGeozones': 'Show geozones',
                'orderWeight': 'Weight',
                'availability': 'Availability',
                'limitOnUpdateTrackAndTraceEta': 'Limit on update track and trace ETA',
                'capacityUnitsTab': 'Capacity units',
                'landmarksLoader': 'Landmarks loading...',
                'fiasTab': 'FIAS',
                'useBorderColorForTypes': 'Use colored borders for indicate types and attributes',
                'locationRNIsRequired': 'Customer location reference number is required',
                'accountCurrencyLabel': 'Currency type',
                'showMapControls': 'Show map controls',
                'home_location': 'Home location',
                'limitOnExportTypesAttributes': 'Limit on export types attributes',
                'addressDataGroup': 'Address information',
                'addPostcodeToOrderName': 'Add postcode to order name',
                'OrderGroup': 'Aditional parameters',
                'orderTooltipScheme': 'Scheme of order\'s columns in tooltip',
                'showAdditionInfo': 'Show Addition info on Track&Trace',
                'additionInfoTemplate': 'Addition info Template',
                'exportTab': 'Export',
                'limitOnGetUsers': 'Limit on get Users',
                'orderImportChunkSize': 'Orders import chunk size',
                'limitOnExportAccountConfigs': 'Limit on export account configs',
                'limitOnGetZoneGroups': 'Limit on get zone groups',
                'planFact': 'Track&Trace',
                'rejectEdit': 'Cancel editing',
                'limitOnGetPerformers': 'Limit on get performers',
                'limitOnExportVehicles': 'Limit on export vehicles',
                'limitOnAutorization': 'Limit on autorization',
                'fiasSettingsGroup': 'FIAS settings',
                'homeLocation': 'Home location',
                'limitOnGetOrdersLog': 'Limit on get orders log',
                'limitOnValidationPerformers': 'Limit on validation performers',
                'limitOnGetAOCS': 'Limit on get AOCS',
                'markerColorScheme': 'Marker coloring scheme',
                'limitOnOrderImport': 'Limit on order import',
                'fiasRestrictRegions': 'Account regions (comma-separated region codes)',
                'limitOnImportAccountConfiguration': 'Limit on import account configuration',
                'limitApiUnallocateOrders': 'Limit API unallocate orders',
                'schedulerTab': 'Scheduler',
                'limitOnApiSchedulingStop': 'Limit on stop scheduling through API',
                'limitOnGetVehicleLocation': 'Limit on get vehicles location',
                'limitOnGetSchedules': 'Limit on get schedules',
                'limitOnValidationVehicleTypes': 'Limit on validation vehicle types',
                'orderDropHue': 'Hue of drop marker',
                'limitOnApiSchedulingStatus': 'Limit on get scheduling status through API',
                'limitOnChangeStatus': 'Limit on change status for instruction',
                'emailAccountSettingsTab': 'Email Settings',
                'limitOnGetOrderStatus': 'Limit on get order status',
                'planedStatusBar': 'Status Bar',
                'PerformerGroup': 'Aditional parameters',
                'dynamic': 'Additional attributes',
                'longitude': 'Longitude',
                'enableVolumeConstraintLabel': 'Enable capacity 2 constraint',
                'limitOnGetOrderDetails': 'Limit on get order details',
                'orderWindowLimit': 'Import order window limit, days',
                'useClusters': 'Use marker clustering',
                'enableCapacityConstraintLabel': 'Enable capacity 1 constraint',
                'globalId': 'External ID',
                'LIMIT_ON_DISTRIBUTION_CENTER_SAVE': 'Limit on creating DC/AoC',
                'tempFilesDirectoryLabel': 'Temp Files Directory',
                'GIS': 'Routing settings',
                'enableCustomerLocationMatching': 'Enable customer location matching',
                'journeySortTemplate': 'Vehicle card sort fields template',
                'limitOnSavingVehicles': 'Limit on saving vehicles',
                'limitOnValidationZones': 'Limit on validation zones',
                'kpiScheme': 'KPI scheme',
                'volumeUnitsLabel': 'Volume units',
                'hideGeozones': 'Hide geozones',
                'limitOnGetOrders': 'Limit on get orders',
                'export_template_file': 'Export Template file',
                'customerLocationVehicleRequirements': 'Customer location vehicle requirements',
                'smsNotificationsTab': 'SMS',
                'actualStatus': 'Actual run status',
                'orderHasCost': 'Order has cost',
                'progressBar': 'Progress Bar',
                'truckInfo': 'Truck',
                'movePlannedAction': 'Move to address',
                'wialonTab': 'Wialon Integration',
                'limitOnGetVehicleTypes': 'Limit on get vehicle types',
                'saveGeozones': 'Save changes',
                'enableUnlimitedRequests': 'Enable unlimited requests',
                'bookingTime': 'Booked time window',
                'useOrderFiltering': 'Use filtering on map',
                'personalDataGroup': 'Personal information',
                'externalId': 'External ID',
                'editGeozones': 'Edit geozones',
                'limitOnImportPerformers': 'Limit on import performers',
                'showRunsCInfo': 'Enable column template on Operational environment',
                'limitOnValidationVehicles': 'Limit on validation vehicles',
                'limitOnGetZones': 'Limit on get zones',
                'limitOnUploadingFile': 'Limit on uploading file',
                'markerType': 'Marker type',
                'runsColumnsTemplate': 'Column template on Operational environment',
                'limitOnSavingVehicleTypes': 'Limit on saving vehicle types',
                'limitOnValidationOrders': 'Limit on validation orders',
                'workPlannedAction': 'Work on address',
                'journeyTemplate': 'Vehicle card custom rows template',
                'addressNotFound': 'No address found',
                'consolidationTool': 'Consolidation Tool',
                'enableSlotBooking': 'Enable Slot booking',
                'limitOnUpdateOrders': 'Limit on update orders',
                'timeWindowAutoReplacement': 'Time Window parameter auto-replacement',
                'suggestionsSearchRadius': 'Search radius for suggestions (meters)'
            },
            'mx.app.mobile.pda.terms.changeETAScreen': {
                'edt': 'Estimated Driving Time',
                'hour': 'Hour',
                'report': 'Report',
                'eat': 'Estimated Arrival Time',
                'screenName': 'Change ETA',
                'minute': 'Minute'
            },
            'mx.comp.CountrySelectCombo': {
                'country': 'Country',
                'emptyText': 'Select a country...',
                'blankText': 'Country is a required field'
            },
            'mail.notification': {
                'subject': 'Vehicles quota reached for "{0}"',
                'body': 'Customer "{0}" on server "{1}" has exceeded the maximum number of vehicles.<br> The current number of vehicles is {2}, the maximum acceptable number of vehicles is {3}.<br><br><br>'
            },
            'mail.sender': {'donotreply': '<br><span style="color: #666666; font-size: 8pt;">Please do not reply to this e-mail. If you have any questions, please contact Maxoptra support team at <a href="mailto:support@maxoptra.com">support@maxoptra.com<\/a><\/span>'},
            'Ext.form.CheckboxGroup': {'blankText': 'You must select at least one item in this group'},
            'mx.app.scheduler': {
                'engineUnallocatedOrder': 'scheduler engine unallocate this order',
                'failPlanningOrder': 'fail planning of order:'
            },
            'mx.comp.Message': {
                'cancel': 'Cancel',
                'no': 'No',
                'yes': 'Yes',
                'warning': 'Warning',
                'information': 'Information',
                'confirmation': 'Confirmation',
                'error': 'Error'
            },
            'mx.app.mobile.pda.terms.operations': {
                'drop1': 'Drop',
                'drop2': 'Drop',
                'pickup1': 'Pick up',
                'pickup2': 'Pick up'
            },
            'ord-ejb.export': {
                '<export-file-can-not-be-create>': 'Export file can not be created',
                '<template-not-found>': 'Export template is not found'
            },
            'mx.app.core.termins.status': {
                'NEW': 'New',
                'DELIVERED': 'Delivered',
                'CLOSED': 'Completed',
                'DETAILS_SENDING': 'Details sending',
                'DELIVERY_ON_MOVE': 'Delivery order started',
                'PICKUP_STARTED': 'Pick up started',
                'PICKUP_ON_MOVE': 'Pickup order started',
                'COMMITTED': 'Sent',
                'COMMITTING': 'Waiting to be sent',
                'PICKUP_ARRIVED': 'Arrived at pick up location',
                'DELIVERY_ARRIVED': 'Arrived at delivery location',
                'FAILED': 'Failed',
                'DETAILS_SENT': 'Waiting to be accepted',
                'DELIVERY_STARTED': 'Delivery started',
                'SUSPENDED': 'Suspended',
                'ALLOCATED': 'Allocated',
                'DELIVERY_FINISHED': 'Delivery finished',
                'PICKUP_FINISHED': 'Pick up finished',
                'DELIVERY_DEPARTED': 'Departed from delivery location',
                'PICKUP_DEPARTED': 'Departed from pick up location'
            },
            'ord-ejb.parse.csv': {
                '<invalid-json-configuration>': 'Can not parse invalid import configuration string.',
                '<csv-transformation-failed>': 'Failed to transform CSV file to a valid format.',
                '<csv-transformation-ioexception>': 'I/O exception during CSV transformation. {0}',
                '<missing_column>': 'Some important columns are missing in your file. Please check your file and import settings or contact support team.'
            },
            'com.magenta.maxoptra.service.impl.ptv.geocoding_country_locator': {
                'Norfolk_Island': 'Norfolk Island',
                'Cambodia': 'Cambodia',
                'Costa_Rica': 'Costa Rica',
                'Spartly_Islands': 'Spartly Islands',
                'El_Salvador': 'El Salvador',
                'Hong_Kong': 'Hong Kong',
                'Kazakhstan': 'Kazakhstan',
                'Paraguay': 'Paraguay',
                'Syria': 'Syria',
                'Bahamas': 'Bahamas',
                'Montserrat': 'Montserrat',
                'Mali': 'Mali',
                'Guadeloupe': 'Guadeloupe',
                'Panama': 'Panama',
                'Central_African_Republic': 'Central African Republic',
                'Laos': 'Laos',
                'Howland_Island': 'Howland Island',
                'Argentina': 'Argentina',
                'Seychelles': 'Seychelles',
                'Navassa_Island': 'Navassa Island',
                'Belize': 'Belize',
                'Burkina_Faso': 'Burkina Faso',
                'Zambia': 'Zambia',
                'Bahrain': 'Bahrain',
                'Congo': 'Congo',
                'Bassas_da_India': 'Bassas da India',
                'Namibia': 'Namibia',
                'Comoros': 'Comoros',
                'Finland': 'Finland',
                'Georgia': 'Georgia',
                'South_Korea': 'South Korea',
                'Yemen': 'Yemen',
                'Eritrea': 'Eritrea',
                'Saint_Pierre_and_Miquelon': 'Saint Pierre and Miquelon',
                'Christmas_Islands': 'Christmas Islands',
                'Glorios_Islands': 'Glorios Islands',
                'Anguilla_Dog_Islands_and_Sombrero': 'Anguilla Dog Islands and Sombrero',
                'Aruba': 'Aruba',
                'Madagascar': 'Madagascar',
                'Libya': 'Libya',
                'Sweden': 'Sweden',
                'Malawi': 'Malawi',
                'Andorra': 'Andorra',
                'Liechtenstein': 'Liechtenstein',
                'Poland': 'Poland',
                'Svalbard': 'Svalbard',
                'Bulgaria': 'Bulgaria',
                'Jordan': 'Jordan',
                'Tunisia': 'Tunisia',
                'Guinea_Bissau': 'Guinea Bissau',
                'Saudi_Arabia': 'Saudi Arabia',
                'Tuvalu': 'Tuvalu',
                'Kenya': 'Kenya',
                'Djibouti': 'Djibouti',
                'Lebanon': 'Lebanon',
                'Azerbaijan': 'Azerbaijan',
                'Cuba': 'Cuba',
                'Mauritania': 'Mauritania',
                'Guernsey': 'Guernsey',
                'Mayotte': 'Mayotte',
                'New_Caledonia': 'New Caledonia',
                'Disputed_Territories': 'Disputed Territories',
                'New_Zealand': 'New Zealand',
                'Dutch_Antilles': 'Dutch Antilles',
                'Israel': 'Israel',
                'Australia': 'Australia',
                'Tajikistan': 'Tajikistan',
                'Antigua_and_Barbuda': 'Antigua and Barbuda',
                'Myanmar': 'Myanmar',
                'Cameroon': 'Cameroon',
                'Gibraltar': 'Gibraltar',
                'Cyprus': 'Cyprus',
                'South_Georgia_and_the_South_Sandwich_Islands': 'South Georgia and the South Sandwich Islands',
                'Sri_Lanka': 'Sri Lanka',
                'Cayman_Islands': 'Cayman Islands',
                'Malaysia': 'Malaysia',
                'Clipperton_Island': 'Clipperton Island',
                'Iceland': 'Iceland',
                'Oman': 'Oman',
                'Armenia': 'Armenia',
                'Gabon': 'Gabon',
                'South_Africa': 'South Africa',
                'Ivory_Coast': 'Ivory Coast',
                'Luxembourg': 'Luxembourg',
                'Brazil': 'Brazil',
                'East_Timor': 'East Timor',
                'Algeria': 'Algeria',
                'Jersey': 'Jersey',
                'Slovenia': 'Slovenia',
                'Faeroe_Islands': 'Faeroe Islands',
                'Colombia': 'Colombia',
                'Ecuador': 'Ecuador',
                'St_Vincent_and_the_Grenadines': 'St Vincent and the Grenadines',
                'Cook_Islands': 'Cook Islands',
                'Moldova': 'Moldova',
                'Trinidad_and_Tobago': 'Trinidad and Tobago',
                'British_Virgin_Islands': 'British Virgin Islands',
                'North_Korea': 'North Korea',
                'Vanuatu': 'Vanuatu',
                'Sao_Tome_and_Principe': 'Sao Tome and Principe',
                'Honduras': 'Honduras',
                'Italy': 'Italy',
                'Antarctica': 'Antarctica',
                'Nauru': 'Nauru',
                'United_Kingdom': 'United Kingdom',
                'Wallis_and_Futuna_Islands': 'Wallis and Futuna Islands',
                'Haiti': 'Haiti',
                'Afghanistan': 'Afghanistan',
                'Burundi': 'Burundi',
                'Singapore': 'Singapore',
                'Brunei_Darussalam': 'Brunei Darussalam',
                'Paracel_Islands': 'Paracel Islands',
                'Russia': 'Russia',
                'Netherlands': 'Netherlands',
                'Europe_Island': 'Europe Island',
                'China': 'China',
                'Martinique': 'Martinique',
                'Kyrgyzstan': 'Kyrgyzstan',
                'Chagos_Archipelago': 'Chagos Archipelago',
                'Reunion': 'Reunion',
                'Bhutan': 'Bhutan',
                'Romania': 'Romania',
                'Togo': 'Togo',
                'Philippines': 'Philippines',
                'Coral_Sea_Islands': 'Coral Sea Islands',
                'Uzbekistan': 'Uzbekistan',
                'Zimbabwe': 'Zimbabwe',
                'Montenegro': 'Montenegro',
                'Dominica': 'Dominica',
                'Indonesia': 'Indonesia',
                'Dominican_Republic': 'Dominican Republic',
                'Benin': 'Benin',
                'Angola': 'Angola',
                'French_Guyana': 'French Guyana',
                'Sudan': 'Sudan',
                'Portugal': 'Portugal',
                'Carolines_Islands': 'Carolines Islands',
                'Grenada': 'Grenada',
                'St_Kitts_and_Nevis': 'St Kitts and Nevis',
                'Greece': 'Greece',
                'Latvia': 'Latvia',
                'Mongolia': 'Mongolia',
                'Iran': 'Iran',
                'Morocco': 'Morocco',
                'Sierra_Leone': 'Sierra Leone',
                'Guatemala': 'Guatemala',
                'Guyana': 'Guyana',
                'Equatorial_Guinea': 'Equatorial Guinea',
                'Puerto_Rico': 'Puerto Rico',
                'Iraq': 'Iraq',
                'Chile': 'Chile',
                'United_States': 'United States',
                'Nepal': 'Nepal',
                'Northern_Mariana_Islands': 'Northern Mariana Islands',
                'French_Polynesia': 'French Polynesia',
                'Tanzania': 'Tanzania',
                'Ukraine': 'Ukraine',
                'Ghana': 'Ghana',
                'India': 'India',
                'Canada': 'Canada',
                'Maldives': 'Maldives',
                'Turkey': 'Turkey',
                'Belgium': 'Belgium',
                'Taiwan': 'Taiwan',
                'United_Arab_Emirates': 'United Arab Emirates',
                'Bermuda': 'Bermuda',
                'Jamaica': 'Jamaica',
                'Peru': 'Peru',
                'Turkmenistan': 'Turkmenistan',
                'Germany': 'Germany',
                'St_Helena': 'St Helena',
                'Fiji': 'Fiji',
                'Tokelau': 'Tokelau',
                'Guinea': 'Guinea',
                'Chad': 'Chad',
                'Somalia': 'Somalia',
                'Thailand': 'Thailand',
                'Kiribati': 'Kiribati',
                'Western_Sahara': 'Western Sahara',
                'Vietnam': 'Vietnam',
                'Czech_Republic': 'Czech Republic',
                'Kuwait': 'Kuwait',
                'Nigeria': 'Nigeria',
                'Croatia': 'Croatia',
                'Uruguay': 'Uruguay',
                'French_Southern_Territories': 'French Southern Territories',
                'Default': 'United Kingdom',
                'Switzerland': 'Switzerland',
                'Baker_Island': 'Baker Island',
                'Samoa': 'Samoa',
                'Palestine': 'Palestine',
                'Spain': 'Spain',
                'Liberia': 'Liberia',
                'Venezuela': 'Venezuela',
                'Virgin_Islands': 'Virgin Islands',
                'Swaziland': 'Swaziland',
                'Palau': 'Palau',
                'Cape_Verde': 'Cape Verde',
                'Estonia': 'Estonia',
                'Heard_and_McDonald_Islands': 'Heard and McDonald Islands',
                'Midway_Islands': 'Midway Islands',
                'Juan_de_Nova_Island': 'Juan de Nova Island',
                'Solomon_Islands': 'Solomon Islands',
                'Turks_and_Caicos_Islands': 'Turks and Caicos Islands',
                'Tromelin_Island': 'Tromelin Island',
                'Niue': 'Niue',
                'Palmyra_Atoll': 'Palmyra Atoll',
                'Austria': 'Austria',
                'Kingman_Reef': 'Kingman Reef',
                'Mozambique': 'Mozambique',
                'Monaco': 'Monaco',
                'Wake_Island': 'Wake Island',
                'Guam': 'Guam',
                'Lesotho': 'Lesotho',
                'Tonga': 'Tonga',
                'Hungary': 'Hungary',
                'Japan': 'Japan',
                'American_Samoa': 'American Samoa',
                'San_Marino': 'San Marino',
                'Belarus': 'Belarus',
                'Mauritius': 'Mauritius',
                'Marshall_Islands': 'Marshall Islands',
                'Albania': 'Albania',
                'Papua_New_Guinea': 'Papua New Guinea',
                'Senegal': 'Senegal',
                'Johnston_Atoll': 'Johnston Atoll',
                'Macedonia': 'Macedonia',
                'Ethiopia': 'Ethiopia',
                'Isle_of_Man': 'Isle of Man',
                'Egypt': 'Egypt',
                'Bolivia': 'Bolivia',
                'Jarvis_Island': 'Jarvis Island',
                'Malta': 'Malta',
                'Pakistan': 'Pakistan',
                'Kosovo': 'Kosovo',
                'Gambia': 'Gambia',
                'Ireland': 'Ireland',
                'Qatar': 'Qatar',
                'Slovakia': 'Slovakia',
                'France': 'France',
                'Lithuania': 'Lithuania',
                'Serbia': 'Serbia',
                'St_Lucia': 'St Lucia',
                'Niger': 'Niger',
                'Rwanda': 'Rwanda',
                'Jan_Mayen': 'Jan Mayen',
                'Ashmore_and_Cartier_Islands': 'Ashmore and Cartier Islands',
                'Bangladesh': 'Bangladesh',
                'Bosnia_and_Herzegovina': 'Bosnia and Herzegovina',
                'Barbados': 'Barbados',
                'Nicaragua': 'Nicaragua',
                'Falkland_Islands': 'Falkland Islands',
                'Norway': 'Norway',
                'Botswana': 'Botswana',
                'Macao': 'Macao',
                'Denmark': 'Denmark',
                'Mexico': 'Mexico',
                'Uganda': 'Uganda',
                'Micronesia': 'Micronesia',
                'Suriname': 'Suriname',
                'Greenland': 'Greenland'
            },
            'mx.app.page.main.settings.Notifications': {
                'headerActive_email': 'E-mail',
                'headerMessage_email': 'E-mail message',
                'headerMessage_sms': 'Sms message',
                'smsNotificationComment': 'The sending of sms messages is off in your account now. Please contact with service of technical support to enable sending sms messages: support@maxoptra.com',
                'notificationTitle': 'SMS/E-mail',
                'headerAction': 'Action',
                'headerActive_sms': 'Sms'
            },
            'mx.app.page.main.dispatching.History': {
                'showHistoryOnMap': 'Show history on map',
                'historyFor': 'History for',
                'showRange': 'Show range'
            },
            'mx.app.mobile.pda.terms.datepickerScreen': {'date': 'Date', 'select': 'Select date', 'time': 'Time'},
            'mx.comp.PagingToolbar': {
                'add': 'Add',
                'lastText': 'Last Page',
                'displayMsg': 'Displaying {0} - {1} of {2}',
                'emptyMsg': 'No data to display',
                'nextText': 'Next Page',
                'refreshText': 'Refresh',
                'beforePageText': 'Page',
                'del': 'Delete',
                'prevText': 'Previous Page',
                'afterPageText': 'of {0}',
                'firstText': 'First Page',
                'imprt': 'Import...',
                'itemsPerPage': 'items per page',
                'showing': 'Show'
            },
            'order.lifecycle': {
                '<delivery_started>': 'Driver sets "on move" for next order',
                '<planned_succesfully>': 'Planned successfully',
                '<cancel_commiting>': 'Cancel execution (cut-off time came)',
                '<allocated>': 'Allocated',
                '<resources>': 'resources',
                '<delivery_departed>': 'Departed from delivery location',
                '<send_order_details_to_performer>': 'Queued to be sent to driver',
                '<DELIVERY_STARTED>': 'Delivery started',
                '<DELIVERY_FINISHED>': 'Delivery finished',
                '<created>': 'Created',
                '<start>': 'Started move to pickup',
                '<committing>': 'Locked',
                '<SUSPENDED>': 'Suspended',
                '<finish>': 'Completed',
                '<details_sending>': 'Details sending',
                '<set_late>': 'Set late',
                '<DETAILS_SENT>': 'Details sent',
                '<committed>': 'Locked',
                '<before_n_days_arrival>': 'N-days before planning arrival time',
                '<pickup_on_move>': 'Started move to pickup location',
                '<decline>': 'Declined',
                '<generate_alert_not_accepted_due_to_no_options>': 'Generate alert \'not accepted due to no options\'',
                '<sms_sending>': 'SMS notification sending',
                '<from>': 'from',
                '<set_failed>': 'Failed',
                '<replanned_succesfully>': 'replanned successfully',
                '<pickup_departed>': 'Departed from pickup location',
                '<trigger_committing>': 'Trigger committing',
                '<PICKUP_FINISHED>': 'Pickup finished',
                '<cancel_commiting_old>': 'Cancel execution (order is in the past)',
                '<completed_order>': 'Order is completed',
                '<change_state_allocated_to_committing>': 'Change state from \'allocated\' to \'waiting to be sent\'',
                '<email_sending>': 'E-mail notification sending',
                '<failed_order>': 'Order is failed',
                '<accepted>': 'Accepted',
                '<updated>': 'Updated',
                '<unallocated>': 'Unallocated',
                '<manual_uncommit>': 'manual unlock',
                '<single_unplanned_succesfully>': 'Unplanned successfully',
                '<created_from_import>': 'Created from import',
                '<lifecycle_action>': 'lifecycle action:',
                '<delivery_arrived>': 'Arrived at delivery location',
                '<unallocated_cut_off_time>': 'Unallocated due to cut off time',
                '<generate_commit_warning>': 'Generate lock warning',
                '<not_loaded>': 'not loaded',
                '<unallocate_starting_period_elapsed>': 'Unallocate (starting period elapsed)',
                '<single_planned_succesfully>': 'Planned successfully',
                '<DELIVERY_ON_MOVE>': 'Started move to delivery location',
                '<PICKUP_STARTED>': 'Pickup started',
                '<pickup_arrived>': 'Arrived at pickup location',
                '<uncommited>': 'Unlocked',
                '<before_arrival>': 'N minutes before estimated time of arrival',
                '<resource_didnt_completed>': 'didn\'t complete',
                '<PICKUP_ON_MOVE>': 'Started move to pickup location',
                '<allocated_in_batch_mode>': 'Scheduled in batch mode',
                '<back_to_committing>': 'Back to locked(Need to re-send details)',
                '<orders>': 'orders',
                '<set_resource_status_unavailable>': 'Set resource status unavailable',
                '<updated_from_import>': 'Updated from import',
                '<generate_alert_not_completed_in_planned_period>': 'Generate alert \'not completed in planned period\'',
                '<manual_unalocation>': 'manual unallocation',
                '<set_resource_status_available>': 'Set resource status available',
                '<details_sent>': 'Order details sent'
            },
            'gt.markerType': {
                '0': 'Simple',
                '1': 'Start time',
                '2': 'End time',
                '3': 'Coloring schemas',
                '4': 'Types and attributes',
                '5': 'Clock'
            },
            'mx.app.widget.XmlFileReport': {
                'singular_performer-types': 'performer type',
                'singular_vehicle-types': 'vehicle type',
                'plural_vehicle-types': 'vehicle types',
                'plural_order-types': 'order types',
                'singular_attributes': 'tag',
                'severityErr': 'ERROR:',
                'singular_order-types': 'order type',
                'file': 'file',
                'customer_locations_CAP': 'Customer locations',
                'plural_landmarks': 'landmarks',
                'plural_types': 'types',
                'context': 'Context',
                'plural_resources': 'resources',
                'performers_CAP': 'Performers',
                'singular_orders': 'order',
                'importSuccessSingular': 'was imported successfully',
                'plural_customer_locations': 'customer locations',
                'singular_types': 'type',
                'importSuccess': 'were imported successfully',
                'singular_customer_locations': 'customer location',
                'plural_performer-types': 'performer types',
                'importReport': 'Import report',
                'exportSuccessfully': 'All entities exported successfully',
                'landmarks_CAP': 'Landmark',
                'nothingImportedCAP': 'Nothing was imported',
                'singular_landmarks': 'landmark',
                'importFromFile': 'Import from file',
                'severityWarn': 'WARNING:',
                'plural_attributes': 'tags',
                'plural_orders': 'orders',
                'importSuccessfully': 'Import was finished successfully',
                'orders_CAP': 'Orders',
                'entity': 'Entity',
                'nothingImported': 'were not imported',
                'singular_resources': 'resource'
            }
        },
        'defaultMapId': 4,
        'availableLanguages': ['en'],
        'addressFormat': ['INFO', 'STREET', 'CITY', 'COUNTY', 'DISTRICT', 'COUNTRY', 'ZIP'],
        'timeZone': 0,
        'largeWeightUnits': 'TONNE',
        'currencyPosition': 'AFTER',
        'UIUpdatePeriod': 60,
        'longDistanceUnits': 'KILOMETRE',
        'dateFormats': {
            'fulldate': 'dd.MM.yyyy',
            'weekstart': 1,
            'fulldatetime': 'dd.MM.yyyy HH:mm',
            'time': 'HH:mm',
            'shortdate': 'dd.MM'
        },
        'currentLanguage': 'en',
        'speedType': 'KILOMETERS_PER_HOUR',
        'defaultMapTitle': 'Russia',
        'weightUnits': 'KILOGRAM',
        'fuelRateUnits': 'LITER_PER_100_KILOMETER'
    });
});
/* */
